/* eslint-disable camelcase */
export const pl = {
  HelpDocs: {
    contractTitle: "Kontrakty",
    contractName1: "Kontrakt Psychologiczny 2024",
    contractName2: "Kontrakt psychologiczny RU 2024",
    contractName3: "Kontrakt Psychologiczny UA 2024",
    contractName4:
      "Polityka ochrony danych osobowych - klauzula Informacyjna 2024",
    policyTitle1: "Polityka ochrony danych osobowych",
    policyName1:
      "Polityka ochrony danych osobowych - klauzula Informacyjna 2024",
    contractFileName1: "/help-documents/pl-pl/kontrakt_psychologiczny_2024.pdf",
    contractFileName2:
      "/help-documents/pl-pl/kontrakt_psychologiczny_ru_2024.pdf",
    contractFileName3:
      "/help-documents/pl-pl/kontrakt_psychologiczny_ua_2024.pdf",
    contractFileName4:
      "/help-documents/pl-pl/polityka_ochrony_danych_osobowych_klauzula_informacyjna_2024.pdf",
    handbookTitle: "Podręcznik i katalog testów",
    handbookName1: "Charakterystyka obszarów diagnozy",
    handbookName2: "Testy psychomotoryczne",
    handbookName3: "Testy poznawcze",
    handbookName4: "Testy osobowości",
    handbookName5: "Katalog testów 03-2024",
    handbookFileName1:
      "/help-documents/pl-pl/charakterystyka_obszarow_diagnozy.pdf",
    handbookFileName2: "/help-documents/pl-pl/testy_psychomotoryczne.pdf",
    handbookFileName3: "/help-documents/pl-pl/testy_poznawcze.pdf",
    handbookFileName4: "/help-documents/pl-pl/testy_osobowosci.pdf",
    handbookFileName5: "/help-documents/pl-pl/katalog_testow_03_2024.pdf",
    modulesTitle: "Moduły wywiadów",
    modulesName1: "Sytuacja zdrowotna",
    modulesName2: "Sytuacja społeczna i rodzinna",
    modulesName3: "Obserwacja",
    modulesName4: "Detektywi ochrona broń MTD I",
    modulesName5: "Koncesja MTD II",
    modulesName6: "Medycyna pracy MTD III",
    modulesName7: "Kierowcy służbowi MTD III",
    modulesName8: "Praca wysokość MTD III",
    modulesName9: "Wózki widłowe MTD III",
    modulesName10: "Psychologia transportu kierowanie pojazdami MTD IV",
    modulesFileName1: "/help-documents/pl-pl/sytuacja_zdrowotna.pdf",
    modulesFileName2: "/help-documents/pl-pl/sytuacja_spoleczna_i_rodzinna.pdf",
    modulesFileName3: "/help-documents/pl-pl/obserwacja.pdf",
    modulesFileName4: "/help-documents/pl-pl/detektywi_ochrona_bron_mtd_I.pdf",
    modulesFileName5: "/help-documents/pl-pl/koncesja_mtd_II.pdf",
    modulesFileName6: "/help-documents/pl-pl/medycyna_pracy_mtd_III.pdf",
    modulesFileName7: "/help-documents/pl-pl/kierowcy_sluzbowi_mtd_III.pdf",
    modulesFileName8: "/help-documents/pl-pl/praca_wysokosc_mtd_III.pdf",
    modulesFileName9: "/help-documents/pl-pl/wozki_widlowe_mtd_III.pdf",
    modulesFileName10:
      "/help-documents/pl-pl/psychologia_transportu_kierowanie pojazdami_mtd_IV.pdf",
  },
  Format: {
    ViewDateTime: "DD.MM.YYYY HH:mm",
    FormDateFormat: "DD.MM.YYYY",
    ExamineeViewDateFormat: "DD.MM.YYYY",
  },
  Buttons: {
    accept: "Zgadzam się",
    addExaminee: "Dodaj badanego",
    addMobileExaminee: "Dodaj",
    importExaminees: "Importuj badanych",
    addPsychLab: "Dodaj konto klienta",
    addPsychUser: "Dodaj konto użytkownika",
    addPsychUserMobile: "Dodaj użytkownika",
    addUser: "Dodaj konto użytkownika",
    addDirectory: "Dodaj folder",
    assign: "Przydziel",
    alreadyAssigned: "Przydzielono",
    assignExamination: "Przydziel badanie",
    alreadyAssignedExamination: "Badanie w toku",
    back: "Powrót",
    backToLogin: "Wróć na stronę logowania",
    begin: "Rozpocznij",
    cancel: "Anuluj",
    change: "Zmień",
    clear: "Wyczyść",
    close: "Zamknij",
    confirm: "Zatwierdź",
    continue: "Dalej",
    createExamination: "Przypisz badanie",
    delete: "Usuń",
    anonymize: "Anonimizuj",
    deleteExaminee: "Usuń badanego",
    deleteExaminees: "Usuń badanych",
    anonymizePsychLab: "Anonimizuj dane",
    deletePsychLab: "Usuń konto klienta",
    deletePsychLabLic: "Usuń licencję",
    downloadAll: "Pobierz wszystkie",
    edit: "Edytuj",
    editExaminee: "Edytuj badanego",
    editPsychLab: "Edytuj konto klienta",
    editPsychLabLic: "Edytuj licencję",
    addPsychLabLic: "Dodaj licencję",
    editPsychLabUser: "Edytuj konto użytkownika",
    examinationWithNoLawBase: "Badanie bez podstawy prawnej",
    examinationWithLawBase: "Badanie z podstawą prawną",
    exit: "Wyjdź",
    generate: "Wygeneruj",
    generateAndPrint: "Wygeneruj i wydrukuj",
    go: "Przejdź",
    goToDashboard: "Przejdź do panelu użytkownika",
    login: "Zaloguj",
    loginPsychLab: "Zaloguj do konta klienta",
    move: "Przenieś",
    moveExaminee: "Przenieś badanego",
    moveExaminees: "Przenieś badanych",
    examineesIdsList: "Pobierz listę badanych",
    ok: "Ok",
    print: "Wydrukuj",
    printContract: "Wydrukuj kontrakt",
    save: "Zapisz",
    savePassword: "Zapisz hasło",
    savePin: "Zapisz PIN",
    saveAndPrint: "Zapisz i wydrukuj",
    saveSettings: "Zapisz ustawienia",
    setPin: "Ustaw PIN",
    search: "Szukaj",
    setPassword: "Ustaw hasło",
    setNewPassword: "Ustaw nowe hasło",
    sendLink: "Wyślij Link",
    skipTests: "Pomiń testy",
    understood: "Rozumiem",
    showActivities: "Wyświetl",
    exportResults: "Generuj eksport",
    exportActivities: "Eksport do pliku XLS",
    enable2FA: "Włącz",
    disable2FA: "Wyłącz",
    enable2FAIcon: "Włącz uwierzytelnianie dwuskładnikowe",
    disable2FAIcon: "Wyłącz uwierzytelnianie dwuskładnikowe",
    saveAndInvate: "Zapisz i zaproś",
    sendEmail: "Wyślij wiadomość",
    unblockedExam: "Odblokuj badania",
    openFolder: "Otwórz",
  },
  Email: {
    bodyupdate: `<div style="color: #000000; font-family: Arial;font-size:12pt;line-height: 1.5rem;">
<p>Szanowni Państwo,<br/><br/>
Z przyjemnością informujemy, że zakończyliśmy aktualizację systemu <strong>OPTIMIS</strong>, która miała miejsce w dniu [30 czerwca 2025 r].<br />Wprowadzone zmiany mają na celu poprawę funkcjonalności i komfortu użytkowania.<br/><br/>Poniżej przedstawiamy kluczowe nowości:<br /><br />
<ol>
<li><strong>Nowy interfejs użytkownika</strong>: Odświeżony wygląd i bardziej intuicyjna nawigacja.</li>
<li><strong>Poprawa wydajności</strong>: Skrócony czas ładowania i szybsze przetwarzanie danych.</li>
<li><strong>Nowe funkcje</strong>: Dodano [np. możliwość personalizacji ustawień, integrację z nowymi narzędziami, raporty w czasie rzeczywistym].</li>
<li><strong>Zwiększone bezpieczeństwo</strong>: Wdrożono dodatkowe zabezpieczenia chroniące dane użytkowników.</li>
</ol>

System jest w pełni dostępny, a wszystkie funkcje działają zgodnie z założeniami.<br/><br/>W razie pytań lub potrzeby wsparcia zapraszamy do kontaktu z naszym zespołem <br/>email: <strong>alta@alta.pl</strong><br/>telefon:<strong>(+48) 515 131 941</strong><br /><br />
Dziękujemy za zaufanie i zapraszamy do zapoznania się z nowymi możliwościami systemu!<br /><br />

Niniejsza wiadomość została wygenerowana automatycznie - prosimy na nią nie odpowiadać.
<br/><br>
Pozdrawiamy,
Zespół ALTA </p>
</div>`,
    subjectupdate: "Aktualizacja oprogramowania",
    bodysys: `<div style="color: #000000; font-family: Arial;font-size:12pt;line-height: 1.5rem;">
<p>Szanowni Państwo,<br/><br/>
Informujemy, że w okresie świątecznym, od <strong>24 grudnia 2025 r.</strong> do <strong>1 stycznia 2026 r.</strong>, nasz helpdesk będzie nieczynny.<br/>System OPTIMIS pozostanie w pełni dostępny i będzie działał bez zmian.<br /><br />


W razie pilnych spraw prosimy o kontakt po zakończeniu przerwy świątecznej<br/>email: <strong>alta@alta.pl</strong><br/>telefon:<strong>(+48) 515 131 941</strong><br /><br />
Dziękujemy za zrozumienie i życzymy Państwu spokojnych oraz radosnych Świąt!<br /><br />

Niniejsza wiadomość została wygenerowana automatycznie - prosimy na nią nie odpowiadać.
<br/><br>
Pozdrawiamy,
Zespół ALTA </p>
</div>`,
    subjectsys: "Przerwa świąteczna",
    subjectbreak: "Przerwa techniczna",
    bodybreak: `<div style="color: #000000; font-family: Arial;font-size:12pt;line-height: 1.5rem;">
<p>Szanowni Państwo,<br/><br/>
Informujemy, że w dniu <strong>[data, np. 30 czerwca 2025 r.]</strong> w godzinach <strong>[np. 22:00 - 02:00]</strong> przeprowadzimy planowaną przerwę techniczną w celu aktualizacji naszego systemu.<br/>W trakcie prac dostęp do systemu Optimis może być czasowo ograniczony lub niedostępny. Prosimy o zaplanowanie pracy z systemem z uwzględnieniem tej przerwy<br /><br />


Przepraszamy za wszelkie niedogodności i dziękujemy za zrozumienie.<br /><br />W razie pytań prosimy o kontakt<br/>email: <strong>alta@alta.pl</strong><br/>telefon:<strong>(+48) 515 131 941</strong><br /><br />

Niniejsza wiadomość została wygenerowana automatycznie - prosimy na nią nie odpowiadać.
<br/><br>
Pozdrawiamy,
Zespół ALTA </p>
</div>`,
  },
  Common: {
    menu: {
      contact: "Pomoc",
      dashboard: "Panel użytkownika",
      folders: "Kartoteka badanych",
      search: "Wyszukaj",
      logout: "Wyloguj",
      settings: "Ustawienia",
      psychlabs: "Kartoteka klientów",
      breadcrumbsPsychLab: "Kartoteka klientów",
      exportResults: "Eksport wyników",
      examineeRegistry: "Rejestr badanych",
      importExaminees: "Import badanych",
      emailSender: "Wysyłanie wiadomości",
      priceList: "Cennik",
      summary: "Rejestr badanych",
    },
    seo: {
      addExaminee: "Dodaj badanego",
      addPsychLabLic: "Dodaj licencję",
      addPsychLab: "Dodaj konto klienta",
      dashboard: "Panel użytkownika",
      editExaminee: "Edytuj badanego",
      helpdesk: "Pomoc",
      helpdeskDocuments: "Dokumenty pomocy",
      judgement: "Orzeczenie",
      login: "Logowanie",
      onboarding: "Onboarding",
      report: "Raport",
      resetPassword: "Resetowanie hasła",
      setNewPassword: "Ustawianie nowego hasła",
      search: "Wyszukiwarka",
      folders: "Kartoteka badanych",
      settings: "Ustawienia",
      exportResults: "Eksport wyników badań",
      emailSender: "Wysyłanie wiadomości",
      examinationAssignment: "Przydzielanie badania z podstawą prawną",
      examinationCard: "Karta Badania",
      priceList: "Cennik",
    },
    warningPopup: {
      text: "Wprowadzone przez Ciebie zmiany nie zostaną zapisane",
      header: "Czy na pewno chcesz wyjść?",
      textSave:
        "Wymagane pola mogą znajdować się również na pozostałych zakładkach",
      headerSave: "Proszę uzupełnić wszystkie wymagane pola!",
      promptLogout:
        "Zostaniesz automatycznie wylogowany za PROMPT_TIME_MINUTES minutę z powodu braku aktywności.",
      promptLogoutCountdown:
        "Zostaniesz automatycznie wylogowany za COUNTDOWN_TIME z powodu braku aktywności.",
      logoutWarningTitle: "Twoja sesja wkrótce wygaśnie",
      promptLogoutInfo:
        "Z powodu braku aktywności zostaniesz automatycznie wylogowany po upływnie minuty.",
      stayLoggedIn: "Przedłuż sesję",
      logoutNow: "Wyloguj teraz",
    },
    logAdminAsUserPopup: {
      text: "Nie udało się zalogować na konto klienta",
      header: "Błąd",
    },
    deleteExamineePopup: {
      text: "Po usunięciu badanego nie będzie możliwości przywrócenia danych",
      header: "Czy na pewno chcesz usunąć badanego?",
      confirmationText: "Tak, chcę usunąć badanego",
    },
    deleteExamineesPopup: {
      text: "Po usunięciu badanych nie będzie możliwości przywrócenia danych",
      header: "Czy na pewno chcesz usunąć zaznaczonych badanych?",
      confirmationText: "Tak, chcę usunąć badanych",
    },
    deleteExamineeWithExamPopup: {
      text: "Po usunięciu badanego wraz z badaniami nie będzie możliwości przywrócenia danych",
      header: "Czy na pewno chcesz usunąć badanego wraz z badaniami?",
      confirmationText: "Tak, chcę usunąć badanego wraz z badaniami",
    },
    deleteExamineesWithExamPopup: {
      text: "Po usunięciu badanych wraz z badaniami nie będzie możliwości przywrócenia danych",
      header: "Czy na pewno chcesz usunąć zaznaczonych badanych wraz z badaniami?",
      confirmationText: "Tak, chcę usunąć badanych wraz z badaniami",
    },
    twoFactorAuth: "Uwierzytelnianie dwuskładnikowe",
  },
  Contact: {
    header: "Pomoc techniczna",
  },
  WhatsNew: {
    closeButton: "Rozumiem",
  },
  LicenseExpire: {
    popup: {
      header: "Uwaga!",
      messageManyDaysBold:
        "Ważność licencji lub ważność konta kończy się za %cnt% dni.",
      messageOneDayBold:
        "Ważność licencji lub ważność konta kończy się za %cnt% dzień.",
      messageRest:
        "Skontaktuj się z nami aby zachować ciągłość pracy i dostęp do wszystkich funkcji systemu.",
      understandButton: "Rozumiem",
      dontShowAgain: "Nie pokazuj więcej",
    },
    expiredPopup: {
      header: "Licencja wygasła",
      message:
        "Twoja licencja na wykonywanie testów w systemie Optimis wygasła.",
      okButton: "OK",
    },
  },
  Cookies: {
    header: "Pozwolenie na użycie cookies",
    consent:
      "W celu świadczenia usług na najwyższym poziomie stosujemy pliki cookies. Korzystanie z naszej witryny oznacza, że będą one zamieszczane w Państwa urządzeniu. W każdym momencie można dokonać zmiany ustawień Państwa przeglądarki.",
    policy: "Polityka cookies",
    showPolicy: "Zobacz politykę cookies",
    cookiePolicy: {
      title: "Polityka dotycząca cookies",
      moduleTitle1: "1. Wstęp",
      moduleText1:
        "Serwis używa plików cookies. W poniższym dokumencie informujemy o korzystaniu z plików cookies w serwisie Optimis.",
      moduleTitle2: "2. Czym są pliki cookies?",
      moduleText2: `Pliki cookies to małe fragmenty tekstu, kodu, które są wysyłane do przeglądarki i które przeglądarka wysyła z powrotem. Niektóre cookies są czasem zapisywane na danym urządzeniu podczas przeglądania serwisu Optimis. Istnieją różne rodzaje plików cookies. Pliki cookies używane w serwisie Optimis zostały podzielone na następujące kategorie:
      a. niezbędne pliki cookies
      b. funkcjonalne
      c. analityczne`,
      moduleTitle3: "3. Z jakich plików cookies korzystamy?",
      moduleText3: `a. Pliki cookies, które są niezbędne do korzystania z serwisu Optimis, służą m.in. do zapewnienia stabilności jego funkcjonowania (mierzą ruch i zabezpieczają nas przed  przeciążeniem). Te pliki cookies są absolutnie niezbędne, aby serwis Optimis mógł świadczyć usługi, i/lub wyłącznie w celu transmisji usług i/lub serwisu Optimis.
      b. Funkcjonalne pliki cookies - zapamiętywanie wybranych preferencji dotyczących prywatności, wypełnień formularzy on-line, zapamiętywanie ustawień strony internetowej.`,
      moduleTitle4: "4. Zgoda na stosowanie plików cookies",
      moduleText4: `Podczas wizyty w serwisie www.gov.pl zostanie wyświetlony komunikat informujący, że wykorzystuje on pliki cookies.`,
      moduleTitle5: "5. Modyfikowanie ustawień plików cookies",
      moduleText5: `W większości przeglądarek internetowych można: kasować pliki typu cookies z twardego dysku komputera (z poziomu ustawień przeglądarki), zablokować wszystkie przysyłane pliki typu cookies lub ustawić ostrzeżenie przed zapisaniem ich na dysku.
      Należy mieć na uwadze, że zmiany ustawień tych plików polegające na ograniczeniu ich stosowania mogą wpłynąć na niektóre funkcjonalności dostępne na stronach internetowych je stosujących.
      Poniżej wskazujemy sposób zmiany ustawień cookies w najbardziej popularnych wyszukiwarkach:`,
      moduleTitle6: "Google Chrome",
      moduleText6: `Menu > Ustawienia > Prywatność i bezpieczeństwo – należy wybrać odpowiednią opcję.`,
      moduleTitle7: "Internet Explorer",
      moduleText7: `Menu > Ustawienia > Pliki cookie i uprawnienia witryny – należy wybrać odpowiednią opcję.`,
      moduleTitle8: "Mozilla Firefox",
      moduleText8: `Menu > Preferencje > Prywatność i bezpieczeństwo > Ciasteczka i dane witryn – należy wybrać odpowiednią opcję.`,
      moduleTitle9: "Opera",
      moduleText9: `Menu > Ustawienia > Prywatność i bezpieczeństwo – należy wybrać odpowiednią opcję.`,
      moduleTitle10: "Safari",
      moduleText10: `Menu > Preferencje > Prywatność > Pliki cookies – należy wybrać odpowiednią opcję. `,
    },
  },
  Dashboard: {
    header: "Ostatnio dodane osoby",
    footer: {
      lastLogin: "Ostatnie logowanie",
      lastFailedLogin: "Ostatnie nieudane logowanie",
      passwordExpired: "Twoje hasło straci ważność za",
      day: "dzień",
      days: "dni",
      versionLabel: "Wersja",
    },
    emptyState: {
      header: "Brak ostatnio dodanych badanych",
      info: "Aby zobaczyć listę badanych dodaj przynajmniej jednego badanego.",
    },
    kebabMenu: {
      print: "Wydrukuj kontrakt",
      profile: "Przejdź do profilu badanego",
    },
  },
  AdminDashboard: {
    header: "Kartoteka klientów",
    showInactiveAccounts: "Pokaż nieaktywne konta",
    expiringLicenses: {
      popupHeader: "Uwaga",
      title: "Lista kont, którym kończy się licencja w ciągu %cnt% dni",
      understandButton: "Rozumiem",
    },
    emptyState: {
      header: "Nie dodano jeszcze kont klientów",
      info: "Aby zobaczyć listę klientów dodaj przynajmniej jedno konto.",
    },
    emptyStateUsers: {
      header: "Nie dodano jeszcze kont użytkowników",
      info: "Aby zobaczyć listę użytkowników dodaj przynajmniej jedno konto użytkownika.",
    },
    emptyStateLicense: {
      header: "Nie dodano jeszcze licencji",
      info: "Aby zobaczyć licencję dodaj ją.",
    },
    kebabMenu: {
      print: "Wydrukuj kontrakt",
      profile: "Przejdź do profilu badanego",
    },
    PsychologicalLabsList: {
      labels: {
        name: "Nazwa klienta",
        clientId: "ID klienta",
        status: "Status",
        systemAccount: "konto systemowe",
        psychCnt: "Liczba użytkowników",
        createDate: "Data utworzenia",
        expireDate: "Ważność konta",
        licenseExpireDate: "Ważność licencji",
        details: "Szczegóły",
        usersCnt: "Liczba użytkowników",
        examineesCnt: "Liczba badanych",
        examinationsCnt: "Liczba badań",
        taskPerPage: "Wierszy na stronę:",
        all: "wszystkie",
        of: "z",
        moreThen: "więcej niż",
      },
      labStatus: {
        enabled: "aktywne",
        disabled: "nieaktywne",
      },
      expiryWarningTooltip:
        "Data ważności licencji lub data ważności konta wygasa w ciągu %count% dni",
      expiredWarningTooltip:
        "Data ważności licencji lub data ważności konta wygasła",
      inactiveAccountTooltip: "Konto nieaktywne",
    },
    Licence: {
      labels: {
        methodologyList: "Dostępne metodyki",
        testsList: "Dostępne testy",
        licenseDate: "Data udzielenie licencji",
        expireDate: "Ważność licencji",
      },
      deletePopup: {
        headerText: "Czy na pewno chcesz usunąć licencję?",
        contentText:
          "Po usunięciu licencji nie będzie możliwości przydzielania badań",
        confirmationText: "Tak, chcę usunąć licencję",
      },
    },
    PsychLab: {
      anonymizePopup: {
        headerText: "Czy na pewno chcesz anonimizować dane klienta?",
        contentText:
          "Wszystkie badania i dane osób badanych zostaną zanonimizowane i przeniesione do konta Psychometric (badania nowe i niezakończone zostaną usunięte). Operacja jest nieodwracalna. Czy chcesz kontynuować?",
        confirmationText: "Tak, chcę anonimizować dane",
      },
      deletePopup: {
        headerText: "Czy na pewno chcesz usunąć konto klienta?",
        contentText:
          "Po usunięciu konta klienta nie będzie możliwości przywrócenia danych",
        confirmationText: "Tak, chcę usunąć konto klienta",
      },
    },
    StatsList: {
      statFileName: "statystyki_badan.xlsx",
    },
    ActivitiesList: {
      labels: {
        date: "Data",
        action: "Czynność",
        executor: "Wykonawca",
        context: "Opis",
        status: "Status",
        errorMsg: "Opis błędu",
      },
      labStatus: {
        success: "ok",
        error: "błąd",
      },
    },
    UsersList: {
      deletePopup: {
        headerText: "Czy na pewno chcesz usunąć konto użytkownika?",
        contentText:
          "Po usunięciu konta użytkownika nie będzie możliwości przywrócenia go",
        confirmationText: "Tak, chcę usunąć konto użytkownika",
      },
      labels: {
        firstName: "Imię",
        lastName: "Nazwisko",
        email: "Email",
        examineeCnt: "Liczba uczestników",
        examinationCnt: "Liczba badań (wszystkie / przydzielone / wykonane)",
        examinationCnt1: "Liczba badań",
        examinationCnt2: "wszystkie: ",
        examinationCnt3: "przydzielone: ",
        examinationCnt4: "wykonane: ",
        isActive: "Status",
        isStaff: "Rola",
      },
      labStatus: {
        enabled: "aktywny",
        disabled: "nieaktywny",
        adminRole: "administrator",
        superUserRole: "super admin",
        userRole: "użytkownik",
        userBaseRole: "rejestrator",
      },
      toolTip: {
        edit: "edytuj",
        move: "przenieś badania i foldery",
        delete: "usuń",
      },
    },
    PsychLabManagment: {
      breadcrumbs: {
        add: "Dodaj konto klienta",
        edit: "Edytuj konto klienta",
        addLicense: "Dodaj licencję",
        editLicense: "Edytuj licencję",
        addUser: "Dodaj konto użytkownika",
        editUser: "Edytuj konto użytkownika",
        dashboard: "Panel użytkownika",
        psychLabs: "Kartoteka klientów",
      },
      header: {
        add: "Dodaj konto klienta",
        edit: "Edytuj konto klienta",
        addUser: "Dodaj konto użytkownika",
        addUserMobile: "Dodaj użytkownika",
        editUser: "Edytuj konto użytkownika",
        editUserMobile: "Edytuj użytkownika",
        addLicense: "Dodaj licencję",
        editLicense: "Edytuj licencję",
      },
      PsychLabView: {
        labels: {
          details: "Szczegóły",
          download: "Pobierz",
          edit: "Edytuj",
          generate: "Wygeneruj",
          name: "Nazwa testu",
          nameFile: "Nazwa pliku",
          print: "Wydrukuj",
          result: "Wynik",
          type: "Rodzaj dokumentu",
        },
        tabs: {
          psychLabData: "Dane klienta",
          license: "Licencja",
          users: "Użytkownicy",
          activityLogs: "Rejestr czynności",
          activityLogsFile: "rejestr_czynnosci",
          activityId: "id",
          activityDate: "data",
          activityAction: "nazwa czynności",
          activityStatus: "status",
          activityContext: "opis",
          activityExecutor: "wykonawca",
          stats: "Statystyki",
          theme: "Wygląd",
          parameters: "Parametry",
          priceList: "Cennik",
        },
        parameters: {
          header: "Parametry klienta",
          noParameters:
            "Brak dostępnych parametrów dla tego klienta. Sprawdź czy licencja jest aktywna.",
        },
      },
    },
  },
  ExaminationAssignmentView: {
    header: "Przydziel badanie",
    labels: {
      chooseExaminationType: "Wybierz typ badania",
      chooseLawBase: "Wybierz podstawę prawną badania",
      description: "Opis",
      legalBase: "Podstawa prawna badania",
      reason: "Cel badania",
      suggestedTestMethods: "PROPONOWANE METODYKI",
      methodologyTest2SafeTlt: "TEST2SAFE",
      methodologyTest2DriveTlt: "TEST2DRIVE",
      methodologyTest2ArmsTlt: "TEST2ARMS",
      methodologyTest2WorkTlt: "TEST2WORK",
      methodologyTest2SafeDesc:
        "metodyka badań psychologicznych dla pracowników ochrony i detektywów",
      methodologyTest2DriveDesc:
        "metodyka przeprowadzania badań kierowców w ramach psychologii transportu",
      methodologyTest2ArmsDesc:
        "metodyka badań psychologicznych, działalność koncesjonowana",
      methodologyTest2WorkDesc:
        "metodyka badań psychologicznych w medycynie pracy",
      methodologyTest2Safe:
        "TEST2SAFE - metodyka badań psychologicznych dla pracowników ochrony i detektywów",
      methodologyTest2Drive:
        "TEST2DRIVE - metodyka przeprowadzania badań kierowców w ramach psychologii transportu",
      methodologyTest2Arms:
        "TEST2ARMS - metodyka badań psychologicznych, działalność koncesjonowana",
      methodologyTest2Work:
        "TEST2WORK - metodyka badań psychologicznych w medycynie pracy",
      freeCredits: "dostępne kredyty: ",
      lockedCredits: "kredyty zablokowane w przydzielonych badaniach: ",
      selectedTestCredits: "kredyty za wybrane testy: ",
    },
    popup: {
      header:
        "Niektóre testy rekomendowane dla wybranej metodyki zostały wyłączone.",
      content: "Czy na pewno chcesz pominąć te testy?",
      headerCredits: "Uwaga",
      contentCredits:
        "Nie można wybrać testu ponieważ suma kredytów za wybrane testy przekracza liczbę dostępnych kredytów.",
      checkbox: "Zapamiętaj wybór dla wszystkich badanych",
    },
    license: "Test niedostępny w wykupionej licencji",
    testAlreadyInExamination: "Ten test jest już dostępny w badaniu",
  },
  PsychologicalTests: {
    psychomotor: "Testy psychomotoryczne",
    cognitive: "Testy poznawcze",
    personality: "Testy osobowościowe",
  },
  ExamineeList: {
    labels: {
      contract: "Kontrakt",
      examine: "Badanie",
      examineLastDate: "Data ostatniego badania",
      allFinishExam: "Przydzielone / zakończone",
      firstName: "Imię",
      folder: "Folder",
      lastName: "Nazwisko",
      peselSlashIdentifier: "PESEL / Identyfikator",
      profile: "Zobacz profil",
      profileShort: "Profil",
      added: "Dodano",
    },
  },
  ExaminationList: {
    withoutLegalBasis: "Badanie bez podstawy prawnej",
    labels: {
      assign: "Przydzielono",
      assignDate: "Data przypisania",
      assignDateMobile: "Dodano",
      create: "Utworzono",
      createDate: "Data utworzenia",
      contract: "Kontrakt",
      documentation: "Dokumentacja",
      end: "Zakończono",
      endDate: "Data zakończenia",
      interview: "Wywiad",
      identificator: "ID",
      language: "Język",
      nameArchiveExamination: "Nazwa baterii",
      nameExamination: "Nazwa badania",
      start: "Rozpoczęto",
      startDate: "Data rozpoczęcia",
      testCnt: "Testy",
      creditsCnt: "Kredyty",
      extendExamMobile: "Dodaj testy",
      recalculateExamMobile: "Przelicz",
      examTlt: "Badanie zawiera:",
      methodologyNameTlt: "metodyki:",
      testNameTlt: "testy:",
    },
    kebabMenu: {
      delete: "Usuń badanie",
    },
    deletePopup: {
      headerText: "Czy na pewno chcesz usunąć badanie?",
      contentText: "Po usunięciu badania nie będzie możliwości przywrócenia go",
      confirmationText: "Tak, chcę usunąć badanie",
    },
    noTestsPopup: {
      headerText: "Brak testów do dodania",
      content:
        "Do badania nie można już dołożyć żadnego testu. Wszystkie testy dostępne w Twojej licencji są już przypisane do tego badania.",
    },
    toolTip: {
      contract: "Generuj kontrakt",
      interview: "Wywiad",
      documentation: "Dokumentacja",
      delete: "Usuń",
      blocked: "badanie zablokowane z powodu braku kredytów",
      extendExam: "Dodaj testy do badania",
      extendExamHidden: "Funkcja ukryta (parametr SHOW_EXTENDED_EXAM=0)",
      recalculateExam: "Przelicz badanie",
      recalculateExamHidden:
        "Funkcja ukryta (parametr SHOW_RECALCULATE_EXAM=0 lub brak uprawnień administratora laboratorium)",
    },
  },
  ArchiveExaminationList: {
    emptyState: {
      info: "Brak badań archiwalnych przypisanych do danego badanego",
    },
  },
  ExaminationView: {
    header: "Dokumentacja",
    breadcrumbs: {
      archive: "Badania archiwalne",
    },
    details: {
      createDate: "Utworzenie badania",
      endDate: "Zakończenie badania",
      identificator: "ID badania",
      language: "Język",
      name: "Nazwa badania",
      startDate: "Data rozpoczęcia badania",
      type: "Nazwa baterii",
    },
    protocols: {
      language: "Język protokołów",
      testProtocol: "Protokół testu",
      noProtocol: "Brak protokołów testów dla wybranego badania",
    },
    labels: {
      details: "Szczegóły",
      download: "Pobierz",
      edit: "Edytuj",
      generate: "Wygeneruj",
      name: "Nazwa testu",
      nameFile: "Nazwa pliku",
      print: "Wydrukuj",
      result: "Wynik",
      type: "Rodzaj dokumentu",
    },
    tabs: {
      documentation: "Dokumentacja",
      protocols: "Protokoły",
      reports: "Raporty",
    },
    common: {
      unavailableInLanguageOption: "Niedostępne w wybranej wersji językowej.",
    },
    aimsKind: {
      aimKind_1: "Opinia psychologiczna - detektywi",
      aimKind_3: "Orzeczenie - pracownik ochrony fizycznej",
      aimKind_8: "Orzeczenie odwoławcze - pracownik ochrony fizycznej",
      aimKind_9: "Orzeczenie - pozwolenie na broń",
      aimKind_10:
        "Orzeczenie  - działalność koncesjonowana o przeznaczeniu wojskowym lub policyjnym",
      aimKind_11:
        "Orzeczenie  - działalność koncesjonowana o przeznaczeniu cywilnym",
      aimKind_12:
        "Orzeczenie odwoławcze - działalność koncesjonowana o przeznaczeniu cywilnym",
      aimKind_13: "Orzeczenie - medycyna pracy",
      aimKind_14:
        "Orzeczenie - medycyna pracy górnictwo i ratownictwo górnicze",
      aimKind_15: "Orzeczenie - medycyna pracy licencja maszynisty",
      aimKind_16:
        "Orzeczenie - kierowca kategoria C1, C1+E, C, C+E, D1, D1+E, D i D+E lub do kierowania tramwajem",
      aimKind_17:
        "Orzeczenie - kierowca przywrócenie uprawnień kategoria AM, A1, A2, A, B1, B, B+E i T",
      aimKind_18:
        "Orzeczenie - kierowca przywrócenie uprawnień przeciwwskazania psychologiczne",
      aimKind_19:
        "Orzeczenie - przedłużenie uprawnień kategoria C1, C1+E, C, C+E, D1, D1+E, D i D+E lub do kierowania tramwajem",
      aimKind_20: "Orzeczenie - kierowca badanie powypadkowe",
      aimKind_21:
        "Orzeczenie - kierowca badanie po spożyciu alkoholu lub środków działających podobnie",
      aimKind_22: "Orzeczenie - kierowca badanie po przekroczeniu 24 pkt",
      aimKind_23: "Orzeczenie - kierowca badanie po co najmniej 2 wykroczeń",
      aimKind_24:
        "Orzeczenie - kierowca badanie przeciwwskazania psychologiczne",
      aimKind_25: "Orzeczenie - kierowca pojazdu uprzywilejowanego",
      aimKind_26:
        "Orzeczenie - kierowca badanie powypadkowe (skierowanie przez starostę)",
      aimKind_27: "Orzeczenie - wykonywanie czynności instruktora",
      aimKind_28: "Orzeczenie - wykonywanie czynności egzaminatora",
      aimKind_29:
        "Orzeczenie - kierowca uczeń lub kandydat na ucznia szkoły ponadpodstawowej kategoria C lub C+E ",
      aimKind_30:
        "Orzeczenie - kierowca słuchacz lub kandydat na słuchacza kursu zawodowego kategoria C lub C+E ",
      aimKind_31: "Orzeczenie - zawód kierowcy skierowany przez pracodawcę",
      aimKind_32: "Orzeczenie - zawód kierowcy samozatrudniony",
    },
  },
  ExamineeView: {
    anonymity: "Badany anonimowy",
    userData: {
      defaultAnonFirstName: "Badany",
      defaultAnonLastName: "Anonimowy",
      pesel: "PESEL",
      sex: "Płeć",
      birthDate: "Data urodzenia",
      address: "Adres",
      education: "Wykształcenie",
      drivingLicense: "Kategoria prawa jazdy",
      identityCard: "Dokument tożsamości",
      serialNumber: "Seria i numer",
      identificator: "Identyfikator",
      drivingLicenseIssuer: "Podmiot wydający prawo jazdy",
      examineName: "Imię i nazwisko",
      phone: "Numer telefonu",
      email: "Adres email",
    },
    drivingLicense: {
      am: "AM",
      a1: "A1",
      a2: "A2",
      a: "A",
      b1: "B1",
      b: "B",
      be: "B+E",
      c: "C",
      c1: "C1",
      c1e: "C1+E",
      ce: "C+E",
      d: "D",
      d1: "D1",
      d1e: "D1+E",
      de: "D+E",
      t: "T",
      tramwaj: "TRAMWAJ",
    },
    tabs: {
      archive: "Badania archiwalne",
      data: "Dane badanego",
      examination: "Badania",
    },
    kebabMenu: {
      edit: "Edytuj dane badanego",
      delete: "Usuń badanego",
    },
    emptyState: {
      header: "Brak badań przypisanych do danego badanego",
      info: "Aby zobaczyć listę badań, przydziel przynajmniej jedno badanie.",
    },
    translations: {
      passport: "paszport",
      id_card: "dowód osobisty",
      male: "mężczyzna",
      female: "kobieta",
      primary: "podstawowe",
      lowerSecondary: "gimnazjalne",
      basicVocational: "zasadnicze zawodowe",
      basicIndustry: "zasadnicze branżowe",
      secondaryIndustry: "średnie branżowe",
      secondary: "średnie",
      higher: "wyższe",
    },
  },
  ExamineeManagment: {
    breadcrumbs: {
      add: "Dodaj badanego",
      import: "Importuj badanych",
      edit: "Edytuj badanego",
      dashboard: "Panel użytkownika",
      directories: "Kartoteka badanych",
    },
    header: {
      add: "Dodaj osobę badaną",
      import: "Importuj badanych",
      edit: "Edytuj dane osoby badanej",
      editMobile: "Edytuj dane",
    },
    importExaminees: {
      filePattern: "Format pliku importu danych",
      fileDesc:
        "Do importu danych wymagany jest plik w formacie CSV. Upewnij się, że Twój plik spełnia poniższe kryteria:",
      fileDesc1: "1. Nagłówek:",
      fileDesc2:
        "Pierwszy wiersz pliku musi zawierać dokładnie następujące nazwy kolumn:",
      fileDesc3: "firstname, lastname, pesel, sex, birthday, anonymous",
      fileDesc4: "2. Dane:",
      fileDesc5:
        "Każdy kolejny wiersz powinien zawierać dane dla jednej osoby, zgodnie z kolejnością kolumn w nagłówku.",
      fileDesc6: "3. Formatowanie danych:",
      fileDesc7: "firstname:",
      fileDesc8: "Imię.",
      fileDesc9: "lastname:",
      fileDesc10: "Nazwisko.",
      fileDesc11: "pesel:",
      fileDesc12: "Numer PESEL. Pozostaw puste, jeśli nie chcesz go podawać.",
      fileDesc13: "sex:",
      fileDesc14: "Płeć - wpisz male (mężczyzna) lub female (kobieta).",
      fileDesc15: "birthday:",
      fileDesc16: "Data urodzenia w formacie rrrr-mm-dd (np. 1985-03-21).",
      fileDesc28: "anonymous:",
      fileDesc29:
        "Badany anonimowy. 1 - badany anonimowy, nie będzie pytany o zgodę na przetwarzanie danych osobowych, nie może posiadać PESEL. 0 - badany z danymi osobowymi",
      fileDesc30: "email:",
      fileDesc31: "Adres e-mail. Pozostaw puste, jeśli nie chcesz go podawać.",
      fileDesc32: "phone:",
      fileDesc33:
        "Numer telefonu. Pozostaw puste, jeśli nie chcesz go podawać.",
      fileDesc17: "Przykład zawartości pliku CSV:",
      downloadCsvExample: "Pobierz przykładowy plik CSV",
      fileDesc18: "firstname,lastname,pesel,sex,birthday,anonymous,email,phone",
      fileDesc19:
        "Jan,Kowalski,85032112345,male,1985-03-21,0,j.kowalski@email.com,123-456-789",
      fileDesc20: "Anna,Nowak,,female,1992-07-10,0,,222-333-444",
      fileDesc21: "Badany,Anonimowy,,male,1995-12-25,1,,",
      fileDesc22: "Wyjaśnienie przykładu:",
      fileDesc23: "Pierwszy wiersz to wymagany nagłówek.",
      fileDesc24:
        "Drugi wiersz zawiera pełne dane Jana Kowalskiego. Podano również email i nr telefonu",
      fileDesc25:
        "Trzeci wiersz zawiera dane Anny Nowak, ale pole pesel jest celowo pozostawione puste bo nie będziemy podawać nr PESEL dla tej osoby. Nie podano adresu email ale podano nr telefonu",
      fileDesc26:
        "Czwarty wiersz zawiera pełne dane Piotra Zielińskiego. Nie podano adresu email ani numeru telefonu",
      fileDesc27:
        "Prosimy o przygotowanie pliku zgodnie z powyższymi instrukcjami, aby zapewnić pomyślny import danych.",
      expand: "rozwiń",
      collapse: "zwiń",
      importFile: "pobierz plik CSV",
      success: "Pomyślnie wczytano plik importu.",
      saveSuccess: "Pomyślnie zaimportowano badanych.",
      noFileSelected: "-",
      tltFileSelected: "podgląd pliku importu: ",
      errors: {
        readFileError: "Błąd odczytu zawartości pliku.",
        fileReadFailed: "Błąd odczytu pliku.",
        invalidPesel: "Plik importu zawiera błędne numery PESEL.",
        invalidPeselFound: "Plik importu zawiera błędne numery PESEL.",
      },
    },
  },
  Forms: {
    selectAll: "zaznacz wszystko",
    emailSender: {
      emailType: "typ wiadomości",
      subject: "tytuł",
      muiRTEtextPlaceHolder: "Treść wiadomości",
      dateSend: "data wysłania",
      userLang: "język użytkownika",
      user: "użytkownik",
      admin: "administrator",
      staff: "rejestrator",
      emailSentSuccessed:
        "Wiadomości zostały zapisane i zostaną wysłane w zaplanowanym czasie",
    },
    exportResults: {
      interview: "wywiad",
      legalBasis: "podstawy prawne badania",
      psychLabs: "klienci",
      folders: "foldery",
      genres: "obszary diagnozy",
      tests: "testy",
      norms: "norma",
      confidenceLevel: "przedział ufności",
      dateFrom: "zakres od",
      dateTo: "zakres do",
      examineeData: "dane badanego",
      examineeAge: "wiek",
      examineeName: "imię i nazwisko",
      examineeSex: "płeć",
      examineeFolder: "nazwa folderu",
      examineeLab: "nazwa klienta",
      examineeEdu: "wykształcenie",
      examineeId: "PESEL/identyfikator",
      resultsData: "wyniki",
      norm: "wyniki znormalizowane",
      normStd: "wyniki znormalizowane - przedziały ufności",
      raw: "wyniki surowe",
      rawStd: "wyniki surowe - przedziały ufności",
      protocol: "protokół",
      exportSucceeded:
        "Zlecenie eksportu zostało przyjęte. O zakończeniu (sukces lub błąd) zostaniesz powiadomiony e-mailem.",
      filesToDownload: "Pliki do pobrania:",
      noFiles: "Brak plików do wyświetlenia.",
      exportDeletedFileSucceeded: "Plik eksportu został usunięty.",
      filesRefresh: "odśwież",
    },
    statsExport: {
      exportSucceeded:
        "Zlecenie eksportu statystyk zostało przyjęte. O zakończeniu (sukces lub błąd) zostaniesz powiadomiony e-mailem.",
      deletedFileSucceeded: "Plik statystyk został usunięty.",
      filesToDownload: "Pliki statystyk do pobrania:",
      noFiles: "Brak plików statystyk do wyświetlenia.",
      filesRefresh: "odśwież",
      rangeRequired: "Należy wybrać zakres dat (od i do).",
    },
    adminFields: {
      yes: "tak",
      no: "nie",
      methodologyTlt: "Metodyka",
      testPsychMotorTlt: "testy psychomotoryczne",
      testCogTlt: "testy poznawcze",
      testPersonTlt: "testy osobowościowe",
      address: "Ulica i numer domu",
      name: "Nazwa",
      firstName: "Imię",
      lastName: "Nazwisko",
      email: "Email",
      password: "Hasło",
      pin: "Kod PIN",
      isActive: "Status konta",
      isStaff: "Rola",
      isSuperuser: "Użytkownik z uprawnieniami administratora",
      isAdmin: "Administrator",
      allowAllAccounts: "Dostęp do wszystkich kont",
      allowAllOwnAndCreated: "Dostęp do własnego konta i kont tworzonych",
      dateExpire: "Ważność konta",
      dateLicExpire: "Data ważności licencji",
      licMethodologies: "Dostępne metodyki",
      licTests: "Dostępne testy",
      city: "Miejscowość",
      postalCode: "kod pocztowy",
      clientId: "ID klienta",
      cin: "Numer wpisu",
      tin: "NIP",
      theme: "Wygląd",
      examineesCnt: "Badani",
      usersCnt: "Użytkownicy",
      dateFrom: "zakres od",
      dateTo: "zakres do",
      activityName: "czynność",
      activityDetails: "Szczegóły",
      status: "status",
      pwdLength: "Długość hasła",
      pwdNumbers: "Cyfra",
      pwdCamelCase: "Duża i mała litera",
      pwdSpecialChar: "Znak specjalny",
      creditsLic: "Licencja na kredyty",
      credits: "Kredyty",
      remainingCredits: "Kredyty pozostałe do wykorzystania",
      allCredits: "Zakupione kredyty",
      lockedCredits: "Kredyty zablokowane w badaniach",
    },
    adminOptions: {
      theme: {
        optimisTheme: "optimis",
        defaultTheme: "default",
      },
      status: {
        active: "aktywne",
        disabled: "nieaktywne",
      },
      admin: {
        admin: "administrator",
        user: "użytkownik",
        baseuser: "rejestrator",
      },
    },
    adminSnackbar: {
      required: "Należy uzupełnić wszystkie pola obowiązkowe.",
      email_unique_error: "Podany adres email już istnieje w bazie!",
      email_wrong_error: "Podany adres email jest niepoprawny!",
      invalidDate: "Data wysłania nie może być wcześniejsza niż aktualna",
      parametersSaved: "Parametry zostały zapisane pomyślnie",
    },
    fields: {
      address: "Ulica i numer domu",
      additionalInfo: "Informacje dodatkowe",
      appealAuthority: "Nazwa instytucji",
      appealDeadline: "Data",
      birthDate: "Data urodzenia",
      city: "Miasto",
      country: "Kraj",
      diffrentIdentificationNumber: "Inny identyfikator",
      directory: "Folder",
      documentDate: "Data wystawienia",
      drivingLicense: "Kategoria prawa jazdy",
      drivingLicenseIssuer: "Podmiot wydający prawo jazdy",
      education: "Wykształcenie",
      identificationNumber: "PESEL",
      identityDocumentType: "Dokument tożsamości",
      identityDocumentNumber: "Seria i numer",
      interval: "Wybierz przedział ufności",
      judgmentNumber: "Numer orzeczenia",
      languageReport: "Wybierz język raportu",
      legalBasis: "Podstawa prawna badania",
      months: "miesiące",
      name: "Imię",
      nextExamination: "Data kolejnego badania",
      postalCode: "Kod pocztowy",
      recipient: "Wybierz odbiorcę",
      sex: "Płeć",
      standard: "Wybierz normę",
      surname: "Nazwisko",
      years: "Lata",
      year: "Rok",
      examineeRegistryId: "Numer w rejestrze osób badanych",
      age: "Wiek",
      date: "Data",
      institutionName: "Nazwa instytucji",
      lang: "Język",
      phone: "Numer telefonu",
      email: "Adres email",
      testName: "Nazwa testu",
      credits: "Cena klienta",
      creditsGlobal: "Cena",
      value: "Wartość",
      values: "Wartości",
    },
    options: {
      genres: {
        cognitive: "procesy poznawcze i intelektualne",
        psychomotor: "psychomotoryka",
        personality: "osobowość",
      },
      exportResultConfidenceLevel: {
        item_85: "0.85",
        item_9: "0.9",
        item_95: "0.95",
        item_99: "0.99",
      },
      activitiesStatus: {
        ok: "ok",
        user_error: "błąd użytkownika",
        server_error: "błąd serwera",
      },
      activities: {
        ALL: "wszystkie",
        AUDIT_ERROR: "Błąd zapisu aktywności",
        ALL_ITEMS: "Wszystkie aktywności",
        APP_REGISTRATION: "Zarejestrowanie aplikacji",
        TEST_RESULT_SUBMITTED: "Przesłanie wyników badania",
        CONSOLE_PIN_VERIFICATION: "Weryfikacja PIN na konsoli użytkownika",
        SAVE_AGREEMENTS:
          "Zapisanie zgód na badanie i przetwarzanie danych osobowych",
        TEST_SKIPPED: "Pominięcie testu na konsoli",
        EXAMINATION_STARTED: "Rozpoczęcie badania",
        EXAMINATION_TERMINATED: "Zakończenie badania",
        ADMIN_LOGGED_OUT: "Wylogowanie administratora",
        ADMIN_CHANGE_LAB_ID: "Zalogowanie administratora na konto klienta",
        USER_LOGGED_IN: "Zalogowanie użytkownika",
        USER_LOGGED_OUT: "Wylogowanie użytkownika",
        PASSWORD_CHANGE_REQUEST: "Żądanie zmiany hasła",
        PASSWORD_CHANGE: "Zmiana hasła",
        PASSWORD_CHANGE_EXPIRED: "Zmiana hasła po wygaśnięciu ważności hasła",
        PIN_CHANGE: "Zmiana numeru PIN",
        DIRECTORY_CREATED: "Utworzenie folderu",
        DIRECTORY_NAME_CHANGED: "Zmiana nazwy folderu",
        DIRECTORY_DELETED: "Usunięcie folderu",
        IMPORT_EXAMINEE: "Import badanych",
        EXAMINEE_ADDED: "Dodanie badanego",
        EXAMINEE_DATA_CHANGE: "Zmiana danych badanego",
        EXAMINEE_DELETED: "Usunięcie danych badanego",
        EXAMINEE_MOVED_TO_DIFFERENT_DIRECTORY:
          "Przeniesienie danych badanego do innego folderu",
        EXAMINATION_ASSIGNED: "Przydzielenie badania",
        EXAMINATION_DELETED: "Usunięcie badania",
        EXAMINATION_REPORT_DOWNLOADED: "Pobranie dokumentów raportów",
        CONTRACT_DOWNLOADED: "Pobranie kontraktu",
        EXAMINATION_PROTOCOL_DOWNLOADED: "Pobranie protokołu badania",
        EXAMINATION_PROTOCOLS_ZIP_DOWNLOADED: "Pobranie protokołów badania ZIP",
        INTERVIEW_CHANGED: "Zmiana wywiadu",
        INTERVIEW_DOWNLOADED: "Pobranie wywiadu",
        ADMIN_LICENCE_ADDED: "Dodanie licencji dla konta klienta",
        ADMIN_LICENCE_CHANGED: "Zmiana licencji konta klienta",
        ADMIN_LICENCE_DELETED: "Usunięcie licencji konta klienta",
        ADMIN_PSYCHOLOGICAL_LAB_ADDED: "Dodanie konta klienta",
        ADMIN_PSYCHOLOGICAL_LAB_DELETED: "Usunięcie konta klienta",
        ADMIN_PSYCHOLOGICAL_LAB_CHANGED: "Zmiana danych konta klienta",
        ADMIN_USER_ADDED: "Dodanie użytkownika do konta klienta",
        ADMIN_USER_DELETED: "Usunięcie użytkownika z konta klienta",
        ADMIN_USER_CHANGED: "Zmiana danych użytkownika do konta klienta",
        ADMIN_LOGGED_IN: "Zalogowanie administratora",
        ADMIN_PRICELIST_CHANGED: "Zmiana globalnego cennika  (administracyjna)",
        ADMIN_LAB_ANONYMIZED: "Anonimizacja danych (administracyjna)",
        EXPORT_RESULTS_GENERATED: "Wygenerowanie eksportu wyników",
        EXPORT_FILE_DOWNLOADED: "Pobranie pliku eksportu wyników",
        EXPORT_FILE_DELETED: "Usunięcie pliku eksportu wyników",
        LAB_PARAMS_BULK_UPDATED: "Aktualizacja parametrów laboratorium",
        EXAMINATION_DOCUMENT_DOWNLOADED: "Pobranie dokumentu badania",
        EXAMINATION_DOCUMENT_CHANGED: "Zmiana dokumentu badania",
        EXAMINATION_EXTENDED: "Rozszerzenie badania o nowe testy",
        IMPORT_EXAMINEE_AND_ASSIGNED_EXAMINATION:
          "Import badanych i przydzielenie badań",
        TEST_TYPE_CREDITS_UPDATED:
          "Zmiana cennika testów dla klienta  (administracyjna)",
        LICENSE_CREDITS_DEDUCTED:
          "Zmniejszenie kredytów przy zapisie wyników testu",
      },
      norms: {
        norm_1: "OPT_1.0.PL",
        norm_2: "OPT_1.0.UA",
        norm_3: "OPT_1.0.RU",
      },
      bool: {
        true: "Tak",
        false: "Nie",
      },
      education: {
        primary: "Podstawowe",
        lowerSecondary: "Gimnazjalne",
        secondary: "Średnie",
        basicVocational: "Zasadnicze zawodowe",
        basicIndustry: "Zasadnicze branżowe",
        secondaryIndustry: "Średnie branżowe",
        higher: "Wyższe",
      },
      identityDocument: {
        idCard: "Dowód osobisty",
        passport: "Paszport",
      },
      sex: {
        female: "Kobieta",
        male: "Mężczyzna",
      },
      lang: {
        polish: "polski",
        english: "angielski",
        espaniol: "hiszpański",
        mexico: "meksykański",
        russian: "rosyjski",
        ukrain: "ukraiński",
      },
      emailType: {
        system: "informacja",
        update: "aktualizacja",
        break: "przerwa techniczna",
      },
      country: {
        afghanistan: "Afganistan",
        albania: "Albania",
        algeria: "Algieria",
        andorra: "Andora",
        angola: "Angola",
        anguilla: "Anguilla",
        antarctica: "Antarktyda",
        antiguaAndBarbuda: "Antigua i Barbuda",
        saudiArabia: "Arabia Saudyjska",
        argentina: "Argentyna",
        armenia: "Armenia",
        aruba: "Aruba",
        australia: "Australia",
        austria: "Austria",
        azerbaijan: "Azerbejdżan",
        bahamas: "Bahamy",
        bahrain: "Bahrajn",
        bangladesh: "Bangladesz",
        barbados: "Barbados",
        belgium: "Belgia",
        belize: "Belize",
        benin: "Benin",
        bermuda: "Bermudy",
        bhutan: "Bhutan",
        belarus: "Białoruś",
        bolivia: "Boliwia",
        bonaireSintEustatiusAndSaba: "Bonaire, Sint Eustatius i Saba",
        bosniaAndHerzegovina: "Bośnia i Hercegowina",
        botswana: "Botswana",
        brazil: "Brazylia",
        bruneiDarussalam: "Brunei",
        britishIndianOceanTerritory: "Brytyjskie Terytorium Oceanu Indyjskiego",
        bulgaria: "Bułgaria",
        burkinaFaso: "Burkina Faso",
        burundi: "Burundi",
        ceuta: "Ceuta",
        chile: "Chile",
        china: "Chiny",
        curacao: "Curaçao",
        croatia: "Chorwacja",
        cyprus: "Cypr",
        chad: "Czad",
        montenegro: "Czarnogóra",
        czechRepublic: "Czechy",
        denmark: "Dania",
        dominica: "Dominika",
        dominicanRepublic: "Dominikana",
        djibouti: "Dżibuti",
        egypt: "Egipt",
        ecuador: "Ekwador",
        eritrea: "Erytrea",
        estonia: "Estonia",
        ethiopia: "Etiopia",
        falklandIslands: "Falklandy",
        fiji: "Fidżi",
        philippines: "Filipiny",
        finland: "Finlandia",
        frenchSouthernTerritories: "Francuskie Terytorium Południowe",
        france: "Francja",
        gabon: "Gabon",
        gambia: "Gambia",
        ghana: "Ghana",
        gibraltar: "Gibraltar",
        greece: "Grecja",
        grenada: "Grenada",
        greenland: "Grenlandia",
        georgia: "Gruzja",
        guam: "Guam",
        guyana: "Gujana",
        guatemala: "Gwatemala",
        guinea: "Gwinea",
        equatorialGuinea: "Gwinea Równikowa",
        guineaBssau: "Gwinea-Bissau",
        haiti: "Haiti",
        spain: "Hiszpania",
        honduras: "Honduras",
        hongKong: "Hongkong",
        india: "Indie",
        indonesia: "Indonezja",
        iraq: "Irak",
        iran: "Iran",
        ireland: "Irlandia",
        iceland: "Islandia",
        israel: "Izrael",
        jamaica: "Jamajka",
        japan: "Japonia",
        yemen: "Jemen",
        jordan: "Jordania",
        caymanIslands: "Kajmany",
        cambodia: "Kambodża",
        cameroon: "Kamerun",
        canada: "Kanada",
        qatar: "Katar",
        kazakhstan: "Kazachstan",
        kenya: "Kenia",
        kyrgyztan: "Kirgistan",
        kiribati: "Kiribati",
        colombia: "Kolumbia",
        comoros: "Komory",
        congo: "Kongo",
        democraticRepublicOfTheCongo: "Kongo, Republika Demokratyczna",
        koreaNorth: "Koreańska Republika Ludowo-Demokratyczna",
        kosovo: "Kosowo",
        costaRica: "Kostaryka",
        cuba: "Kuba",
        kuwait: "Kuwejt",
        lao: "Laos",
        lesotho: "Lesotho",
        lebanon: "Liban",
        liberia: "Liberia",
        libyan: "Libia",
        liechtenstein: "Liechtenstein",
        lithuania: "Litwa",
        luxembourg: "Luksemburg",
        latvia: "Łotwa",
        northernMacedonia: "Macedonia Północna",
        madagascar: "Madagaskar",
        mayotte: "Majotta",
        macao: "Makau",
        malawi: "Malawi",
        maldives: "Malediwy",
        malaysia: "Malezja",
        mali: "Mali",
        malta: "Malta",
        northernMarianaIslands: "Mariany Północne",
        morocco: "Maroko",
        mauritania: "Mauretania",
        mauritius: "Mauritius",
        mexico: "Meksyk",
        melilla: "Melilla",
        micronesia: "Mikronezja",
        usMinorOutlyingIslands:
          "Minor (Powiernicze Wyspy Pacyfiku Stanów Zjednoczonych)",
        moldova: "Mołdawia",
        mongolia: "Mongolia",
        montserrat: "Montserrat",
        mozambique: "Mozambik",
        myanmar: "Myanmar (Birma)",
        namibia: "Namibia",
        nauru: "Nauru",
        nepal: "Nepal",
        netherlands: "Niderlandy",
        germany: "Niemcy",
        niger: "Niger",
        nigeria: "Nigeria",
        nicaragua: "Nikaragua",
        niue: "Niue",
        norfolk: "Norfolk",
        norway: "Norwegia",
        newCaledonia: "Nowa Kaledonia",
        newZealand: "Nowa Zelandia",
        palestinian: "Palestyna",
        oman: "Oman",
        pakistan: "Pakistan",
        palau: "Palau",
        panama: "Panama",
        papuaNewGuinea: "Papua Nowa Gwinea",
        paraguay: "Paragwaj",
        peru: "Peru",
        pitcairn: "Pitcairn",
        frenchPolynesia: "Polinezja Francuska",
        poland: "Polska",
        southAfrica: "Południowa Afryka",
        southGeorgiaAndSouthSandwichIslands:
          "Południowa Georgia i Południowe Wyspy Sandwich",
        portugal: "Portugalia",
        southKorea: "Republika Korei",
        centralAfricanRepublic: "Rep. Środkowoafrykańska",
        russia: "Rosja",
        rwanda: "Rwanda",
        westernSahara: "Sahara Zachodnia",
        saintBarthelemy: "Saint Barthelemy",
        romania: "Rumunia",
        elSalvador: "Salwador",
        samoa: "Samoa",
        americanSamoa: "Samoa Amerykańskie",
        sanMarino: "San Marino",
        senegal: "Senegal",
        serbia: "Serbia",
        seychelles: "Seszele",
        sierraLeone: "Sierra Leone",
        singapore: "Singapur",
        swaziland: "Suazi",
        slovakia: "Słowacja",
        slovenia: "Słowenia",
        somalia: "Somalia",
        sriLanka: "Sri Lanka",
        stPierreAndMiquelon: "St. Pierre i Miquelon",
        stKittsandAndNevis: "St.Kitts i Nevis",
        stLucia: "St.Lucia",
        stVincentAndTheGrenadines: "St.Vincent i Grenadyny",
        unitedStatesOfAmerica: "Stany Zjednoczone Ameryki",
        sudan: "Sudan",
        southSudan: "Sudan Południowy",
        suriname: "Surinam",
        syrian: "Syria",
        switzerland: "Szwajcaria",
        sweden: "Szwecja",
        stHelena: "Święta Helena",
        tajikistan: "Tadżykistan",
        thailand: "Tajlandia",
        taiwan: "Tajwan",
        tanzania: "Tanzania",
        togo: "Togo",
        tokelau: "Tokelau",
        tonga: "Tonga",
        trinidadAndTobago: "Trynidad i Tobago",
        tunisia: "Tunezja",
        turkey: "Turcja",
        turkmenistan: "Turkmenistan",
        turksAndCaicosIslands: "Wyspy Turks i Caicos",
        tuvalu: "Tuvalu",
        uganda: "Uganda",
        ukraine: "Ukraina",
        uruguay: "Urugwaj",
        uzbekistan: "Uzbekistan",
        vanuatu: "Vanuatu",
        wallisAndFutuna: "Wallis i Futuna",
        vatican: "Watykan",
        venezuela: "Wenezuela",
        hungary: "Węgry",
        unitedKingdom: "Wielka Brytania",
        vietnam: "Wietnam",
        italy: "Włochy",
        timorLeste: "Wschodni Timor",
        coteDivoire: "Wybrzeże Kości Słoniowej",
        bouvetIsland: "Wyspa Bouveta",
        christmasIsland: "Wyspa Bożego Narodzenia",
        cookIslands: "Wyspy Cooka",
        virginIslandsUSA: "Wyspy Dziewicze-USA",
        virginIslandsBritish: "Wyspy Dziewicze-W.B",
        heardAndMcdonaldIslands: "Wyspy Heard i McDonald",
        cocosIslands: "Wyspy Kokosowe (Keelinga)",
        faroeIslands: "Wyspy Owcze",
        marshallIslands: "Wyspy Marshalla",
        solomonIslands: "Wyspy Salomona",
        sintMaartenDutch: "Wyspa Sint Maarten (Niderlandy)",
        saoTomeAndPrincipe: "Wyspy Św. Tomasza i Książęca",
        zambia: "Zambia",
        capeVerde: "Zielony Przylądek",
        zimbabwe: "Zimbabwe",
        unitedArabEmirates: "Zjednoczone Emiraty Arabskie",
        unitedKingdomNorthernIreland:
          "Zjednoczone Królestwo (Irlandia Północna)",
      },
      recipient: {
        examinee: "Osoba badana",
        psychologist: "Psycholog",
        specialist: "Specjalista",
      },
      languagesDocumentation: {
        pl: "polski",
        en: "angielski",
      },
    },
    pwdFields: "Polityka haseł",
    extraFields: "Dane uzupełniające",
    requiredFields: "Dane obowiązkowe",
    passwordFields: "Ustawienia hasła",
    anonymous: "Badanie anonimowe",
    snackbar: {
      peselLength: "PESEL musi składać się z 11 cyfr",
      peselNumber: "PESEL może składać się tylko z liczb",
      required: "Należy uzupełnić wszystkie pola obowiązkowe.",
    },
  },
  FormValidation: {
    max: "Nazwa nie może mieć więcej niż 128 znaków",
    required: "To pole jest obowiązkowe",
    Pin: {
      length: "Musi zawierać 4 cyfry",
    },
    Password: {
      length: "Minimum %lenght% znaków",
      settings: "Musi zawierać:",
      camelCase: "wielką literę i małą literę",
      spacialChar: "znak specjalny",
      number: "cyfrę",
    },
  },
  Helpdesk: {
    header: "Pomoc",
    subheader: "Help desk",
    text1:
      "Zgłoszenia dotyczące błędów lub nieprawidłowości w działaniu Systemu należy przesłać drogą elektroniczną na adres: ",
    text2: "optimis@alta.pl",
    text3: "Telefoniczna linia pomocy technicznej jest dostępna w dni robocze",
    text4: "w godzinach 8:00-16:00",
    phoneNo: "tel.",
    mobile: "tel.",
    help: "Pomoc zdalna",
    contact: "Kontakt",
    documents: {
      header: "Dokumenty pomocy",
      labels: {
        download: "Pobierz",
        name: "Nazwa dokumentu",
      },
    },
    phoneNo1: "(+48) 32 249 50 40",
    phoneNo2: "(+48) 515 131 941",
    phoneNo3: "",
    emailValue: "",
  },
  Interview: {
    header: "Wywiad",
    inputAdditionalInformation: "Wpisz dodatkowe informacje",
    inputHoursOfWork: "Wpisz ilość godzin pracy w ostatniej dobie",
    years: "Lata",
    months: "Miesiące",
    hours: "Godziny",
    tabs: {
      currentPsychophysicalState: "Sytuacja zdrowotna",
      socialAndFamilySituation: "Sytuacja społeczna i rodzinna",
      observation: "Obserwacja",
      drivingVehicles: "Kierowanie pojazdami",
      occupationalMedicine: "Medycyna pracy",
      securityAndDetectives: "Detektywi i pracownicy ochrony",
      licensedActivities: "Działalność koncesjonowana",
    },
    questions: {
      questionAnswers: {
        yes: "tak",
        no: "nie",
      },
      questionTexts: {
        when: "Kiedy ? ",
        sinceWhen: "Od kiedy ?",
        forHowLong: "Do kiedy ?",
        why: "Z jakiego powodu ?",
        whatAreTheConsequences: "Jakie były skutki zdrowotne ?",
        describeTheCircumStancesOfUsage: "Opisz okoliczności tego użycia",
      },
      methodologies: {
        currentPsychophysicalState: {
          headers: {
            currentState: "Aktualny stan psychofizyczny",
            criticalEvents: "Zdarzenia krytyczne",
          },
          questionExtendedTexts: {
            commonText: "Opisz okoliczności tego zdarzenia/sytuacji",
          },
          questionTexts: {
            question1:
              "Czy osoba badana spożywała alkohol w ciągu ostatnich 48 godzin?",
            question2:
              "Czy osoba badana w ciągu ostatniej lub przedostatniej nocy pracowała zawodowo?",
            question3: "Liczba godzin pracy w ostatniej dobie",
            question4: "Uraz głowy wymagający pomocy medycznej",
            question5: "Utrata przytomności",
            question6: "Pobyt w szpitalu",
            question7:
              "Czy kiedykolwiek miało miejsce lub aktualnie ma miejsce leczenie z powodu/" +
              " czy pojawiło się kiedykolwiek rozpoznanie następujących chorób:",
            question7a:
              "a. chorób układu pokarmowego (choroby wrzodowej żołądka lub dwunastnicy, zaburzeń czynności jelit itp.) ",
            question7b:
              "b. chorób serca i układu krążenia (choroby wieńcowej, podwyższenia ciśnienia tętniczego krwi)",
            question7c:
              "c. zaburzeń słuchu lub wzroku (nie dotyczy noszenia okularów korekcyjnych)",
            question7d: "d. cukrzycy",
            question7e: "e. epilepsji ",
            question7f:
              "f. chorób psychicznych (depresja, nerwica," +
              " leczenie psychiatryczne (dopytać o leczenie psychiatryczne członka bliskiej rodziny)",
            question8:
              "Używanie leków na stałe (dopytać o to, czy zna /" +
              " ma świadomość działań ubocznych i dopytać o inne leki wpływające na funkcje psychiczne)",
            question9: "Problemy ze snem",
            question10: "Korzystanie z pomocy:",
            question10a: "a. psychologa",
            question10b: "b. lekarza psychiatry",
            question10c: "c. neurologa",
            question11: "Orzeczenie niepełnosprawności",
            question12: "Problemy z powodu picia alkoholu",
            question13: "Pobyt w izbie wytrzeźwień",
            question14:
              "Używanie środków odurzających/psychoaktywnych/narkotyki",
            question15:
              "Sugestie lekarza lub kogoś bliskiego podjęcia leczenia ze względu na nerwowość," +
              " roztargnienie lub problemy z pamięcią lub orientacją",
          },
        },
        socialAndFamilySituation: {
          questionTexts: {
            question1:
              "Poważny konflikt lub problem związany z pracą " +
              "(np. wypadek w pracy, nagana, sąd pracy, zwolnienie dyscyplinarne, mobbing)",
            question2:
              "Problemy na etapie kształcenia " +
              "(np. powtarzanie klasy, wyrzucenie ze szkoły, zawieszenie w prawach ucznia)",
            question3:
              "Poważny konflikt rodzinny lub problemy w sytuacjach prywatnych " +
              "(np. sprawy sądowe, udział w bójkach, można dopytać o status związku, dzieci) ",
            question4:
              "Sytuacja bezpośredniego zagrożenia życia (np. pożar, powódź i inne katastrofy)",
            question5:
              "Doznanie aktu przemocy fizycznej na własnej osobie (np. napaść, kradzież, pobicie)",
            question6:
              "Zaangażowanie w działania organizacji społecznych (np. wolontariat)",
            question7: "Karalność (np. otrzymanie mandatu, wyrok sądu) ",
          },
        },
        observation: {
          questionTexts: {
            question1: "Kontakt z rozmówcą",
            question2: "Język i retoryka wypowiedzi",
            question3: "Nastrój i nastawienie",
            question4: "Opanowanie i kontrola zachowań i emocji",
          },
          questionAnswers: {
            question1a:
              "Nawiązuje bardzo dobry kontakt z rozmówcą; utrzymuje kontakt wzrokowy;" +
              " zachowuje się pewnie i swobodnie, nie pozwala się wytrącić z równowagi czy zniecierpliwić," +
              " zachowuje się spontanicznie i naturalnie. ",
            question1b:
              "Nawiązuje kontakt z rozmówcą; utrzymuje kontakt wzrokowy; zachowuje się naturalnie," +
              " choć widoczne są oznaki pewnego zdenerwowania. ",
            question1c:
              "Zachowuje się w sposób zdystansowany, unika kontaktu wzrokowego; zachowuje się nienaturalnie," +
              " małe bodźce powodują wytrącenie z równowagi, widoczne są wyraźne oznaki zdenerwowania i zniecierpliwienia. ",
            question2a:
              "Formułuje wypowiedzi używając poprawnego języka," +
              " buduje jasne, czytelne zdania, utrzymuje logiczną strukturę wypowiedzi," +
              " wykorzystuje bogaty zasób słownictwa.  ",
            question2b:
              "Formułuje poprawnie wypowiedzi, " +
              "generalnie utrzymuje ich logiczną strukturę; zasób słów przeciętny, ale poprawny. ",
            question2c:
              "Formułuje krótkie, zdawkowe wypowiedzi, często niespójne lub niejasne;" +
              " używa niepoprawnych zwrotów i sformułowań; zdania są bardzo proste," +
              " słownictwo bardzo ubogie, występują błędy gramatyczne. ",
            question3a:
              "Obserwowalny bardzo pogodny, optymistyczny nastrój; zadowolenie z siebie i swojej sytuacji życiowej. ",
            question3b:
              "Obserwowalny umiarkowany nastrój, dość pozytywne nastawienie i generalnie optymistyczne spojrzenie w przyszłość. ",
            question3c:
              "Obserwowalne nieproporcjonalnie silne reakcje emocjonalne," +
              " wyraźna skłonność do pesymistycznego odbioru świata; okazywanie niezadowolenia. ",
            question4a:
              "W trakcie badania adekwatnie kontroluje swoje zachowanie i emocje," +
              " adekwatnie dostosowuje się do pojawiających się okoliczności. ",
            question4b:
              "W trakcie badania na ogół kontroluje swoje zachowanie i emocje;" +
              " najczęściej adekwatnie reaguje na pojawiające się okoliczności. ",
            question4c:
              "W trakcie badania obserwowalne trudności z kontrolowaniem zachowań i emocji;" +
              " pojawiają się nieadekwatne zachowania lub emocje. ",
          },
        },
        drivingVehicles: {
          headers: {
            drivingCharacteristics: "Charakterystyka przejeżdżanych tras",
          },
          questionTexts: {
            question1: "Staż w prowadzeniu pojazdów ogólnie",
            question2: "Staż w prowadzeniu pojazdów na stanowisku kierowcy",
            question3: "Liczba rocznie przejechanych kilometrów",
            question4: "Liczba godzin spędzanych na prowadzeniu samochodu",
            question5: "Długość tras ",
            question6: "Różnorodność",
            question7: "Pory dnia ",
            question8: "Zmiennik",
            question9: "Obszar",
            question10: "Zatrzymanie lub odebranie prawa jazdy",
            question11: "Orzeczenie niezdolności do prowadzenia pojazdów",
            question12: "Kara za wykroczenie lub przestępstwo drogowe",
            question13: "Udział jako kierowca w wypadku samochodowym",
            question14: "Uczestnictwo jako kierowca w kolizji drogowej",
            question15: "Posiadane dodatkowe uprawnienia i licencje",
          },
          questionAnswers: {
            question3a: "mniej niż 3 000 km rocznie",
            question3b: "między 3 000 – 15 000 km rocznie",
            question3c: "między 15 000 - 70 000 km rocznie",
            question3d: "powyżej 70 000 km rocznie",
            question3e: "trudno powiedzieć",

            question4a: "mniej niż 5 godzin tygodniowo",
            question4b: "między 5 - 15 godzin tygodniowo",
            question4c: "między 15 - 40 godzin tygodniowo",
            question4d: "powyżej 40 godzin tygodniowo",
            question4e: "trudno powiedzieć",

            question5a: "jeżdżę przeważnie na krótkich trasach",
            question5b: "jeżdżę przeważnie na długich trasach",
            question5c: "jeżdżę zarówno na długich jak i na krótkich trasach",

            question6a: "jeżdżę zazwyczaj na stałych trasach",
            question6b: "jeżdżę najczęściej na różnych trasach",

            question7a: "jeżdżę najczęściej nocą",
            question7b: "jeżdżę zwykle w ciągu dnia",
            question7c: "jeżdżę zarówno w ciągu dnia jak i nocą",

            question8a: "jeżdżę głównie samodzielnie bez zmiennika",
            question8b: "jeżdżę najczęściej ze zmiennikiem",

            question9a: "jeżdżę głównie w mieście",
            question9b: "jeżdżę głównie poza miastem",

            question13a: "jako sprawca/współsprawca",
            question13b: "jako poszkodowany",
            question13c: "nie dotyczy",

            question14a: "jako sprawca/współsprawca",
            question14b: "jako poszkodowany",
            question14c: "nie dotyczy",

            question15a: "przewóz materiałów niebezpiecznych",
            question15b: "przewóz osób",
            question15c: "instruktor prawa jazdy",
            question15d: "egzaminator prawa jazdy",
            question15e: "brak",
          },
        },
        occupationalMedicine: {
          headers: {
            workInformation: "Informacje dotyczące pracy zawodowej",
            workCourseInformation: "Przebieg pracy zawodowej",
            companyCarDrivers: "Kierowcy samochodów służbowych",
            workingAtHeights: "Praca na wysokości",
            forkliftOperators: "Operatorzy wózków widłowych",
            minersAndMinerLifeguards: "Górnicy i ratownicy górniczy",
            trainDriver: "Maszyniści",
          },
          questionTexts: {
            question1: "Zawód wyuczony",
            question2: "Zawód wykonywany",
            question3: "Miejsce pracy / szkoła",
            question4: "Stanowisko / wykonywane czynności",
            question5:
              "Czynniki szkodliwe/uciążliwe występujące na stałe w miejscu pracy",
            question5f: "Jakie ?",
            question5g: "Jakie ?",
            question6: "Staż pracy ogółem",
            question7: "Staż pracy na obecnym stanowisku",
            question8: "Stwierdzono chorobę zawodową",
            question8a: "Kiedy? Z jakiego powodu?",
            question9: "Przyznano świadczenie rentowe",
            question9a: "Z jakiego powodu? Od kiedy? Do kiedy?",
            question10: "Osoba badana uległa wypadkowi w pracy",
            question10a: "Kiedy? Jakie były skutki zdrowotne?",
            question11: "Orzeczono niepełnosprawność",
            question11a: "Z jakiego powodu? Od kiedy? Do kiedy?",
            question12: "Staż w prowadzeniu pojazdów ogólnie",
            question13: "Liczba rocznie przejechanych kilometrów",
            question14: "Liczba godzin spędzanych na prowadzeniu samochodu",
            question15: "Orzeczenie niezdolności do prowadzenia pojazdów",
            question16: "Zatrzymanie lub odebranie prawa jazdy",
            question17: "Kara za wykroczenie lub przestępstwo drogowe",
            question18: "Udział jako kierowca w wypadku samochodowym ",
            question19: "Uczestnictwo jako kierowca w kolizji drogowej",
            question20:
              "Posiadanie uprawnień do wykonywania pracy na wysokości",
            question21:
              "Wykonywanie prac na wysokości (jeśli tak, dopytać, ile metrów nad ziemią)",
            question22:
              "Subiektywne odczuwanie lęku podczas przebywania na wysokości",
            question23: "Wypadek podczas pracy na wysokości",
            question23a: "Czy nastąpiło uszkodzenie mienia lub zdrowia?",
            question24:
              "Posiadanie uprawnień do wykonywania pracy operatora wózka widłowego",
            question25:
              "Wykonywanie prac związanych z obsługą i prowadzeniem wózka widłowego",
            question26:
              "Wypadek podczas obsługi lub prowadzenia wózka widłowego",
            question26a: "Czy nastąpiło uszkodzenie mienia lub zdrowia?",
          },
          questionAnswers: {
            question5a: "Praca monotonna",
            question5b: "Stały duży dopływ informacji",
            question5c: "Wysoki poziom hałasu",
            question5d:
              "Praca z dużym obciążeniem psychicznym (odpowiedzialność i decyzyjność)",
            question5e: "Promieniowanie jonizujące ",
            question5f: "Czynniki chemiczne",
            question5g: "Inne",

            question13a: "mniej niż 3 000 km rocznie",
            question13b: "między 3 000 – 15 000 km rocznie",
            question13c: "między 15 000 - 70 000 km rocznie",
            question13d: "powyżej 70 000 km rocznie",
            question13e: "trudno powiedzieć",

            question14a: "mniej niż 5 godzin tygodniowo",
            question14b: "między 5 - 15 godzin tygodniowo",
            question14c: "między 15 - 40 godzin tygodniowo",
            question14d: "powyżej 40 godzin tygodniowo",
            question14e: "trudno powiedzieć",

            question18a: "jako sprawca/współsprawca",
            question18b: "jako poszkodowany",
            question18c: "nie dotyczy",

            question19a: "jako sprawca/współsprawca",
            question19b: "jako poszkodowany",
            question19c: "nie dotyczy",
          },
        },
        licensedActivity: {
          questionTexts: {
            question1:
              "Staż pracy ogółem w zakładzie pracy zajmującym " +
              "się działalnością koncesjonowaną",
            question2: "Stanowisko/ wykonywane czynności",
            question3:
              "Staż pracy na obecnym stanowisku w " +
              "zakładzie pracy zajmującym się działalnością koncesjonowaną",
            question4a: "Udział w wypadku w miejscu pracy",
            question4b:
              "Jakie były przyczyny, konsekwencje wypadku - czy nastąpiło uszkodzenie mienia, zdrowia?",
          },
        },
        detectivesSecurityGuardsAndWeaponPermits: {
          questionTexts: {
            question1: "Podstawowe cele wykorzystania broni:",
            question1g: "Jakie ?",
            question2:
              "Czy kiedykolwiek miało miejsce użycie broni " +
              "lub innych środków przymusu bezpośredniego?",
            question3:
              "Jak często miało miejsce użycie broni w ciągu ostatnich 5 lat?",
          },
          questionAnswers: {
            question1a: "do celów zawodowych (detektyw, pracownik ochrony)",
            question1b: "do celów łowieckich",
            question1c: "do celów sportowych",
            question1d: "do użytku osobistego",
            question1e: "do celów muzealnych, pamiątkowych, naukowych",
            question1f: "inne",
          },
        },
      },
    },
  },
  Language: { pl: "PL", ru: "RU", uk: "UK" },
  SearchEngine: {
    header: "Wyszukaj badanych",
    placeholderMobile: "Wyszukaj",
    placeholderDesktop:
      "Imię, nazwisko, PESEL/Identyfikator, data przydzielenia badania (RRRR-MM-DD)",
    noResults: "Brak wyników wyszukiwania",
    noResultsForFilter:
      "Nie znaleziono żadnych badanych spełniających wprowadzone wymagania.",
    searchForExaminees: "Wyszukaj badanych",
    enterFilter:
      "Wyszukiwać możesz po imieniu, nazwisku, numerze PESEL/Identyfikator\n" +
      "lub po dacie przydzielenia badania \n" +
      "w formacie RRRR-MM-DD.",
  },
  AdminSearchEngine: {
    header: "Wyszukaj klientów",
    placeholderMobile: "Wyszukaj",
    placeholderDesktop:
      "nazwa, ID, adres, NIP, data utworzenia, data ważności konta klienta w formacie RRRR-MM-DD, imię, nazwisko, email użytkownika, data ważności licencji, metodyka, test",
    noResults: "Brak wyników wyszukiwania",
    noResultsForFilter:
      "Nie znaleziono żadnych klientów spełniających wprowadzone wymagania.",
    searchForExaminees: "Wyszukaj klientów",
    enterFilter:
      "Wyszukiwać możesz po nazwie, ID, adresie, NIP, dacie utworzenia, dacie ważności konta klienta w formacie RRRR-MM-DD, imieniu, nazwisku, email użytkownika, dacie ważności licencji w formacie RRRR-MM-DD, metodyce, teście.",
  },
  Snackbars: {
    createExamineeSuccess: "Pomyślnie dodano badanego",
    editExamineeSuccess: "Pomyślnie edytowano badanego",
    createPsychLabSuccess: "Pomyślnie dodano konto klienta",
    editPsychLabSuccess: "Pomyślnie edytowano konto klienta",
    anonymizePsychLabSuccess: "Dane klienta zostały zanonimizowane",
    anonymizePsychLabEmptySuccess:
      "Brak badań do zanonimizowania. Dane klienta zostały oczyszczone.",
    deletePsychLabSuccess: "Pomyślnie usunięto konto klienta",
    failedRequest: "Wystąpił problem: ",
    movingExamineesSuccess: "Przeniesienie do innego folderu powiodło się",
    examineesListGeneratedSuccess: "Pomyślnie wygenerowano listę badanych",
    examineesListGeneratedError: "Nie udało się wygenerować listy badanych",
    deleteExamineeSuccess: "Pomyślnie usunięto badanego",
    bulkDeleteExamineesSuccess: "Pomyślnie usunięto badanych: %{deleted}",
    bulkDeleteExamineesPartial:
      "Usunięto badanych: %{deleted}. Pominięto (posiadają badania): %{skipped}",
    passwordChangeSuccess: "Zmiana hasła powiodła się",
    pinChangeSuccess: "Zmiana PINu powiodła się",
    success: "Akcja powiodła się",
    unrecognizedError: "Nierozpoznany błąd, sprawdź połączenie z internetem",
    createExaminationSuccess: "Poprawnie przydzielono badanie",
    extendExaminationSuccess: "Poprawnie rozszerzono badanie o nowe testy",
    recalculateExaminationSuccess: "Przeliczono wyniki badania",
    createMultiExaminationSuccess:
      "Poprawnie zaimportowano i przydzielono badania",
    deleteExaminationSuccess: "Poprawnie usunięto badanie",
    editPsychUserSuccess: "Pomyślnie edytowano użytkownika",
    transferUserDataSuccess: "Pomyślnie przeniesiono badania i foldery",
    createPsychUserSuccess: "Pomyślnie dodano użytkownika",
    createPsychLicSuccess: "Pomyślnie dodano licencję",
    editPsychLicSuccess: "Pomyślnie edytowano licencję",
    editTestCreditSuccess: "Pomyślnie zapisano cenę testu w kredytach",
    editTestCreditError: "Nie udało się zapisać ceny testu w kredytach",
    unblockedExamSuccess: "Pomyślnie odblokowano badania klienta",
  },
  LandscapePrompt: {
    title: "Obróć urządzenie poziomo",
    description:
      "Edycja dokumentacji nie jest możliwa w trybie pionowym. Aby kontynuować, obróć telefon poziomo.",
  },
  ExportResults: {
    header: "Eksport wyników badań",
    headerMobile: "Eksport wyników badań",
    exportActivities: "Eksport do pliku XLS",
    popups: {
      delete: {
        confirmationHeader: "Czy na pewno chcesz usunąć plik eksportu?",
        confirmationText:
          "Po usunięciu pliku eksportu nie będzie możliwości przywrócenia go.",
        confirmationCheckboxLabel: "Tak, chcę usunąć plik eksportu",
      },
    },
  },
  StatsExport: {
    popups: {
      delete: {
        confirmationHeader: "Czy na pewno chcesz usunąć plik statystyk?",
        confirmationText:
          "Po usunięciu pliku statystyk nie będzie możliwości przywrócenia go.",
        confirmationCheckboxLabel: "Tak, chcę usunąć plik statystyk",
      },
    },
  },
  RegistryResults: {
    header: "Rejestr badanych",
    headerMobile: "Rejestr badanych",
    clientAccounts: "Konta klientów",
    clientAccountsRequired:
      "Wymagany jest wybór co najmniej jednego konta klienta.",
    foldersRequired: "Wybierz co najmniej jeden folder.",
    legalBasisRequired: "Wybierz co najmniej jedną podstawę prawną badania.",
    folders: "Foldery",
    dateFrom: "Data od",
    dateTo: "Data do",
    legalBasis: "Podstawy prawne badania",
    generateButton: "Generuj rejestr",
    filesToDownload: "Pliki do pobrania",
    filesRefresh: "Odśwież listę plików",
    noFiles: "Brak wygenerowanych plików.",
    exportSucceeded:
      "Zlecenie generowania rejestru zostało przyjęte. O zakończeniu (sukces lub błąd) zostaniesz powiadomiony e-mailem.",
    dateRangeError: 'Data "od" nie może być późniejsza niż data "do".',
    exportDeletedFileSucceeded: "Plik rejestru został usunięty.",
    popups: {
      delete: {
        confirmationHeader: "Czy na pewno chcesz usunąć plik rejestru?",
        confirmationText:
          "Po usunięciu pliku rejestru nie będzie możliwości przywrócenia go.",
        confirmationCheckboxLabel: "Tak, chcę usunąć plik rejestru",
      },
    },
  },
  PriceList: {
    header: "Cennik testów",
    headerMobile: "Cennik testów",
    testName: "Nazwa testu",
    credits: "Kredyty",
  },
  SendEmail: {
    header: "Wysyłanie powiadomień",
    headerMobile: "Wysyłanie powiadomień",
  },
  UserSettings: {
    header: "Ustawienia konta",
    headerChangePassword: "Zmiana hasła",
    headerChangePin: "Zmiana PIN",
    setNewPin: "Ustaw nowy PIN",
    pinInfo:
      "Wprowadź PIN jaki będziesz wykorzystywać do logowania do konsoli psychologa.",
    headerMobile: "Ustawienia",
    access: "Dostęp",
    facilityInfo: "Dane pracowni",
    userInfo: "Dane użytkownika",
    passwordChange: "Zmiana hasła",
    passwordExpiry: "Twoje hasło wygasa: ",
    pinChange: "Zmiana numeru pin",
    pinChangeMobile: "Zmiana PIN",
    infoSubHeaders: {
      labName: "Nazwa",
      address: "Adres",
      cin: "Numer wpisu do rejestru",
      id: "Identyfikator",
      tin: "NIP",
      firstName: "Imię",
      lastName: "Nazwisko",
      email: "Email",
      dateExpire: "Data ważności konta",
      licenseNumber: "Numer licencji",
      assignedClientAccount: "Konto klienta do którego jesteś przypisany",
    },
    license: {
      license: "Licencja",
      dateLicExpire: "Data ważności licencji: ",
      remainingCredits: "Kredyty pozostałe do wykorzystania: ",
      allCredits: "Zakupione kredyty: ",
      lockedCredits: "Kredyty zablokowane w badaniach: ",
      freeCredits: "Dostępne kredyty: ",
    },
    helpdeskMsgUser:
      "Jeśli chcesz zmienić dane pracowni lub użytkownika to zadzwoń na numer:",
    helpdeskMsgLab:
      "Jeśli chcesz zmienić dane pracowni lub użytkownika to zadzwoń na numer:",
  },
  Backend: {
    User_activation_code_has_already_been_used:
      "Kod aktywacyjny został już użyty.",
    User_activation_code_does_not_exist: "Podany kod aktywacyjny nie istnieje.",
    User_with_given_id_does_not_exist: "Użytkownik z danym id nie istnieje.",
    Token_not_recognized: "Token nie został rozpoznany.",
    Unrecognized_token_Please_regenerate_password_reset_link:
      "Nierozpoznany token, proszę wygenerować nowy link do resetowania hasła.",
    Invalid_token_Please_regenerate_password_reset_link:
      "Nieprawidłowy token, proszę wygenerować nowy link do resetowania hasła.",
    Validation_failed: "Walidacja wprowadzonych danych nieudana.",
    Could_not_bind_users_PsychologicalLab_with_the_examinee:
      "Nie udało się powiązać placówki użytkownika z badanym.",
    Could_not_bind_users_PsychologicalLab_with_the_directory:
      "Nie udało się powiązać placówki użytkownika z folderem.",
    The_password_cannot_be_the_same_as_the_previous_one:
      "Hasło nie może być takie samo jak poprzednie.",
    Incorrect_credentials: "Błędne hasło.",
    Unrecognized_email:
      "Adres email nie został rozpoznany lub konto nie zostało aktywowane.",
    Directory_has_related_Examinees:
      "Brak możliwości usunięcia Folderu: Folder ma powiązanych badanych.",
    Unable_to_delete_default_directory:
      "Brak możliwości usunięcia Folderu Domyślnego.",
    The_new_pin_cannot_be_the_same_as_the_previous_one:
      "Nowy PIN nie może być taki sam jak poprzedni.",
    Directory_with_given_name_already_exists:
      "Folder z daną nazwą już istnieje.",
    Examination_Card_does_not_have_a_defined_NormSet:
      "Karta badania nie posiada przypisanej normy badania.",
    Examinee_with_the_given_id_exists_in_this_psychological_lab:
      "Badany o podanym numerze PESEL już istnieje w bazie.",
    Generated_ID_conflict: "Błąd generowania identyfikatora dla badanego.",
    The_Examinee_has_related_Examinations:
      "Brak możliwości usunięcia Badanego: Badany ma powiązane badania.",
    Unrecognized_proxy_error_occurred_while_fetching_legacy_data:
      "Nierozpoznany błąd pobierania danych archiwalnych.",
    Legacy_data_instance_not_found: "Nie znaleziono danych archiwalnych.",
    Legacy_data_validation_failed: "Błąd walidacji danych archiwalnych.",
    Unable_to_parse_Examination_Aim: "Błąd walidacji Celu Badania.",
    Unable_to_parse_Occupational_Medicine_Basic_Info_data:
      "Błąd walidacji Przebiegu Badania - Medycyna Pracy",
    Ongoing_examination: "Brak możliwości usunięcia Badania. Badanie w toku.",
    User_has_related_Examinations_or_Directories:
      "Brak możliwości usunięcia Użytkownika: Użytkownik ma powiązane badania lub foldery.",
  },
  Onboarding: {
    errorText:
      "Podczas ustawiania hasła nastąpił błąd, spróbuj ponownie później.",

    successTitle: "Hasło oraz PIN ustawione",
    success:
      "Twoje hasło oraz PIN zostały zapisane. Możesz teraz pierwszy raz zalogować się do aplikacji używając swojego adresu email oraz hasła.",
    setNewPasswordInfo:
      "Wprowadź hasło jakie będziesz wykorzystywać do logowania do systemu.",
    setPasswordFormLabel: "Ustaw hasło",
    setPinInfo:
      "Wprowadź PIN jaki będziesz wykorzystywać do logowania do konsoli psychologa.",
    setPinFormLabel: "Ustaw swój PIN",
  },
  ResetPassword: {
    formHeader: "Resetuj Hasło",
    resetInfo:
      "Wprowadź adres email swojego konta, aby otrzymać link do resetowania hasła.",
    resetEmailSentPt1: "Na adres e-mail: ",
    resetEmailSentPt2:
      " została wysłana wiadomość zawierająca instrukcje dotyczące procesu resetowania hasła.",
    errorText:
      "Podczas resetowania hasła nastąpił błąd, spróbuj ponownie później.",
    successTitle: "Zapisano Hasło",
    success:
      "Twoje hasło zostało zmienione. Możesz teraz zalogować się do aplikacji używając swojego adresu email oraz nowego hasła.",
    setNewPassword: "Ustaw nowe hasło",
    setNewPasswordInfo:
      "Wprowadź hasło jakie będziesz wykorzystywać do logowania do systemu.",
  },
  FormLabels: {
    email: "E-mail",
    password: "Hasło",
    currentPassword: "Obecne hasło",
    newPassword: "Nowe hasło",
    pin: "PIN",
  },
  FormValidationErrors: {
    required: "To pole jest wymagane",
    email: "Wprowadzona wartość nie jest adresem email",
    passwordMinLength: "Hasło musi mieć co najmniej %{minLength} znaków",
    passwordRequirements:
      "Twoje hasło nie spełnia wszystkich wymaganych warunków",
    pinLength: "PIN musi mieć dokładnie 4 cyfry",
    pinDigitsOnly: "PIN może zawierać tylko cyfry",
  },
  Login: {
    header: "LOGOWANIE",
    adminHeader: "PANEL ADMINISTRACYJNY",
    error: "Błędny e-mail lub hasło.",
    warning: "CAPS LOCK jest włączony",
    reset: "Zresetuj hasło",
    Instance_configured_incorrectly:
      "Błąd konfiguracji systemu. Zgłoś problem pomocy technicznej.",
    No_recaptcha_token_provided:
      "Błąd recaptcha. Zgłoś problem pomocy technicznej.",
    Validation_failed: "Błędny e-mail lub hasło.",
    Laboratory_is_inactive_or_deleted: "Nieaktywne konto klienta",
    Laboratory_account_has_expired:
      "Nie można się zalogować — konto straciło ważność.",
    User_account_is_not_active: "Nieaktywne konto użytkownika",
    User_account_has_been_deleted: "Konto użytkownika zostało usunięte",
    Captcha_error: "Błąd wypełaniania captcha. Spróbuj ponownie.",
    Access_denied: "Odmowa dostępu",
  },
  Directory: {
    defaultFolderName: "Folder domyślny",
    header: "Kartoteka badanych",
    popup: {
      create: "Podaj nazwę folderu",
      edit: "Zmień nazwę folderu",
    },
    emptyState: {
      header: "Brak badanych w wybranym folderze",
      info: "Aby zobaczyć listę badanych w folderze dodaj do niego przynajmniej jednego badanego",
    },
    labels: {
      name: "Nazwa folderu",
      owner: "Właściciel",
      examineeCount: "Osoby",
    },
    kebabMenu: {
      addExaminee: "Dodaj badanego",
      addDirectory: "Dodaj folder",
      edit: "Edytuj nazwę folderu",
      delete: "Usuń folder",
    },
    popups: {
      delete: {
        confirmationHeader: "Czy na pewno chcesz usunąć folder?",
        confirmationText:
          "Po usunięciu folderu nie będzie możliwości przywrócenia go.",
        confirmationCheckboxLabel: "Tak, chcę usunąć folder",
      },
    },
  },
  DirectoryPreview: {
    headerPopup: "Przenieś badanych",
    labels: {
      firstName: "Imię",
      lastName: "Nazwisko",
      peselSlashIdentifier: "PESEL / Identyfikator",
      lastModification: "Ostatnia aktywność",
    },
    kebabMenu: {
      edit: "Edytuj dane badanego",
      move: "Przenieś badanego",
      delete: "Usuń badanego",
    },
    breadcrumbs: "Kartoteka badanych",
  },
  MoveExamAndFoldersPopup: {
    header: "Przenieś badania i foldery",
    userInfo: "Dane użytkownika",
    examinations: "Liczba badań",
    examAll: "wszystkie badania",
    examAssign: "przydzielone badania",
    examDone: "wykonane badania",
    directories: "Foldery użytkownika",
    noDirectories: "Brak folderów",
    selectTargetUser:
      "Wybierz użytkownika, do którego przeniesiesz badania i foldery",
    selectTargetUserLabel: "Użytkownik docelowy",
    noActiveUsers: "Brak aktywnych użytkowników",
    moveButton: "Przenieś",
  },
  Pagination: {
    outOf: "z",
  },
  PasswordExpired: {
    popup: {
      header: "Upłynęła ważność hasła",
      text: "W celu ustawienia nowego hasła zostaniesz przeniesiony do procesu ustawienia nowego hasła.",
    },
    form: {
      header: "Ustaw nowe hasło",
      text: "Wprowadź hasło jakie będziesz wykorzystywać do logowania do systemu.",
    },
    success: {
      header: "Zapisano hasło",
      text: "Twoje hasło zostało zmienione. Możesz teraz przejść do aplikacji.",
    },
  },
  DocumentationManagement: {
    snackbar: {
      save: "Pomyślnie zapisano dokument",
    },
    names: {
      ExaminationCard: "Karta badania",
      ExaminationCardTEST2WORK: "Karta badania TEST2WORK",
      ExaminationCardTEST2SAFE: "Karta badania TEST2SAFE",
      ExaminationCardTEST2ARMS: "Karta badania TEST2ARMS",
      ExaminationCardTEST2DRIVE: "Karta badania TEST2DRIVE",
      PsychologicalConsultation: "Konsultacja psychologiczna",
      PsychologicalConsultationTEST2WORK: "Konsultacja psychologiczna",
      PsychologicalConsultationTEST2SAFE: "Konsultacja psychologiczna",
      PsychologicalConsultationTEST2ARMS: "Konsultacja psychologiczna",
      PsychologicalConsultationTEST2DRIVE: "Konsultacja psychologiczna",
      PsychologicalOpinion: "Opinia psychologiczna",
      PsychologicalOpinionTEST2WORK: "Opinia psychologiczna",
      PsychologicalOpinionTEST2SAFE: "Opinia psychologiczna - detektywi",
      PsychologicalOpinionTEST2ARMS: "Opinia psychologiczna",
      PsychologicalOpinionTEST2DRIVE: "Opinia psychologiczna",
      CivilExplosivesJudgment:
        "Orzeczenie broń i materiały wybuchowe na użytek cywilny",
      CivilExplosivesJudgmentTEST2WORK:
        "Orzeczenie broń i materiały wybuchowe na użytek cywilny",
      CivilExplosivesJudgmentTEST2SAFE:
        "Orzeczenie broń i materiały wybuchowe na użytek cywilny",
      CivilExplosivesJudgmentTEST2ARMS:
        "Orzeczenie broń i materiały wybuchowe na użytek cywilny",
      CivilExplosivesJudgmentTEST2DRIVE:
        "Orzeczenie broń i materiały wybuchowe na użytek cywilny",
      DriverJudgment: "Orzeczenie kierowanie pojazdami",
      DriverJudgmentTEST2WORK: "Orzeczenie kierowanie pojazdami",
      DriverJudgmentTEST2SAFE: "Orzeczenie kierowanie pojazdami",
      DriverJudgmentTEST2ARMS: "Orzeczenie kierowanie pojazdami",
      DriverJudgmentTEST2DRIVE: "Orzeczenie kierowanie pojazdami",
      DrivingExaminerJudgment: "Orzeczenie egzaminator jazdy",
      DrivingExaminerJudgmentTEST2WORK: "Orzeczenie egzaminator jazdy",
      DrivingExaminerJudgmentTEST2SAFE: "Orzeczenie egzaminator jazdy",
      DrivingExaminerJudgmentTEST2ARMS: "Orzeczenie egzaminator jazdy",
      DrivingExaminerJudgmentTEST2DRIVE: "Orzeczenie egzaminator jazdy",
      DrivingInstructorJudgment: "Orzeczenie instruktor jazdy",
      DrivingInstructorJudgmentTEST2WORK: "Orzeczenie instruktor jazdy",
      DrivingInstructorJudgmentTEST2SAFE: "Orzeczenie instruktor jazdy",
      DrivingInstructorJudgmentTEST2ARMS: "Orzeczenie instruktor jazdy",
      DrivingInstructorJudgmentTEST2DRIVE: "Orzeczenie instruktor jazdy",
      DrivingTechniqueInstructorJudgment:
        "Orzeczenie instruktor techniki jazdy",
      EmergencyVehicleDriverJudgment: "Orzeczenie pojazdy uprzywilejowane",
      EmergencyVehicleDriverJudgmentTEST2WORK:
        "Orzeczenie pojazdy uprzywilejowane",
      EmergencyVehicleDriverJudgmentTEST2SAFE:
        "Orzeczenie pojazdy uprzywilejowane",
      EmergencyVehicleDriverJudgmentTEST2ARMS:
        "Orzeczenie pojazdy uprzywilejowane",
      EmergencyVehicleDriverJudgmentTEST2DRIVE:
        "Orzeczenie pojazdy uprzywilejowane",
      FirearmLicenseJudgment: "Orzeczenie pozwolenie na broń",
      FirearmLicenseJudgmentTEST2WORK: "Orzeczenie pozwolenie na broń",
      FirearmLicenseJudgmentTEST2SAFE: "Orzeczenie pozwolenie na broń",
      FirearmLicenseJudgmentTEST2ARMS: "Orzeczenie pozwolenie na broń",
      FirearmLicenseJudgmentTEST2DRIVE: "Orzeczenie pozwolenie na broń",
      MilitaryExplosivesJudgment:
        "Orzeczenie broń i materiały policyjne lub wojskowe",
      MilitaryExplosivesJudgmentTEST2WORK:
        "Orzeczenie broń i materiały policyjne lub wojskowe",
      MilitaryExplosivesJudgmentTEST2SAFE:
        "Orzeczenie broń i materiały policyjne lub wojskowe",
      MilitaryExplosivesJudgmentTEST2ARMS:
        "Orzeczenie broń i materiały policyjne lub wojskowe",
      MilitaryExplosivesJudgmentTEST2DRIVE:
        "Orzeczenie broń i materiały policyjne lub wojskowe",
      OccupationalMedicineJudgmentTEST2WORK: "Orzeczenie medycyna pracy",
      OccupationalMedicineJudgmentTEST2SAFE: "Orzeczenie medycyna pracy",
      OccupationalMedicineJudgmentTEST2ARMS: "Orzeczenie medycyna pracy",
      OccupationalMedicineJudgmentTEST2DRIVE: "Orzeczenie medycyna pracy",
      PhysicalProtectionJudgment: "Orzeczenie licencja ochroniarza",
      PhysicalProtectionJudgmentTEST2WORK: "Orzeczenie licencja ochroniarza",
      PhysicalProtectionJudgmentTEST2SAFE:
        "Orzeczenie - pracownik ochrony fizycznej",
      PhysicalProtectionJudgmentTEST2ARMS: "Orzeczenie licencja ochroniarza",
      PhysicalProtectionJudgmentTEST2DRIVE: "Orzeczenie licencja ochroniarza",
      ProfessionalDriverJudgment: "Orzeczenie stanowisko kierowcy",
      ProfessionalDriverJudgmentTEST2WORK: "Orzeczenie stanowisko kierowcy",
      ProfessionalDriverJudgmentTEST2SAFE: "Orzeczenie stanowisko kierowcy",
      ProfessionalDriverJudgmentTEST2ARMS: "Orzeczenie stanowisko kierowcy",
      ProfessionalDriverJudgmentTEST2DRIVE: "Orzeczenie stanowisko kierowcy",
    },
    emptyState: {
      header: "Badanie nie zostało zakończone",
    },
    report: {
      details: {
        assignDate: "Data przydzielenia badania",
        endDate: "Data zakończenia badania",
        firstName: "Imię",

        PESEL: "PESEL",
        identificationNumber: "Identyfikator",
        idExamination: "ID badania",
        lastName: "Nazwisko",
        name: "Nazwa badania",
        status: "Status badania",
      },
      statusExamination: {
        skip: "Pominięto lub przerwano niektóre testy",
      },
      header: {
        language: "Wybierz język raportu",
        standard: "Wybierz normę",
        recipient: "Wybierz odbiorcę",
        interval: "Wybierz przedział ufności",
        reportInterpretation: "Raport interpretacyjny",
        reportDiagnostic: "Raport diagnostyczny",
        reportDiagnosticCharts: "Raport diagnostyczny z wykresami",
      },
    },
    consultation: {
      breadcrumbs: "Konsultacja psychologiczna",
      examineeData: "Dane badanego",
      statement: "stwierdzam",
    },
    opinion: {
      breadcrumbs: "Opinia psychologiczna",
      breadcrumbsAppeal: "Opinia psychologiczna odwoławcza",
      examineeData: "Dane badanego",
      statement:
        "NA PODSTAWIE PRZEPROWADZONEGO BADANIA PSYCHOLOGICZNEGO STWIERDZAM",
    },
    judgment: {
      isAppealTitle: "ORZECZENIE ODWOŁAWCZE",
      appeal: "Od niniejszego orzeczenia służy prawo odwołania się do",
      appealDate: "W terminie",
      appealDay: "W terminie",
      appealDay2: "dni od dnia jego otrzymania",
      appealDayTlt: "Liczba dni",
      drivingLicense: "W zakresie prawa jazdy kategorii",
      judgmentNumber: "Orzeczenie psychologiczne nr",
      judgmentNumberAppeal: "Orzeczenie psychologiczne nr",
      legalBais: "Podstawa prawna badania",
      statement: "Stwierdzam*",
      occupationalMedicineStatement: "Orzekam*",
      statementThat: "Stwierdzam, że",
      nextLegalBasis: "Podstawa prawna następnego badania:",
      remarks: "Uwagi",
      ART_1: "art. 39k ust. 3 pkt 1",
      ART_2: "art. 39k ust. 3 pkt 2",
      examiner_ART_1: "art. 34 ust. 5 pkt 1",
      examiner_ART_2: "art. 34 ust. 5 pkt 2",
      header: {
        base: "Orzeczenie",
        baseAppeal: "Orzeczenie odwoławcze",
        baseAppealFooter: "Niniejsze orzeczenie jest ostateczne.",
        civilExplosives: "Działalność koncesjonowana - do użytku cywilnego",
        civilExplosivesAppeal:
          "Działalność koncesjonowana - do użytku cywilnego - odwołanie",
        driver: "Kierowanie pojazdami",
        emergencyVehicleDriver: "Kierowca pojazdu uprzywilejowanego",
        firearmLicense: "Pozwolenie na broń",
        militaryExplosives:
          "Działalność koncesjonowana - o przeznaczeniu wojskowym lub policyjnym",
        physicalProtection: "Pracownik ochrony",
        profesionalDriver: "Stanowisko kierowcy",
        drivingInstructor: "Instruktor",
        drivingExaminer: "Egzaminator",
        occupationalMedicine: "Medycyna pracy",
      },
      emergencyVehicleDriver: {
        true: "brak przeciwwskazań do kierowania pojazdem uprzywilejowanym lub przewożącym wartości pieniężne",
        false:
          "istnienie przeciwwskazań do kierowania pojazdem uprzywilejowanym lub przewożącym wartości pieniężne",
      },
      drivingVehicles: {
        true: "brak przeciwwskazań psychologicznych kierowania pojazdami",
        false: "istnienie przeciwwskazań psychologicznych kierowania pojazdami",
      },
      physicalProtection: {
        true: "posiada zdolność do wykonywania zadań pracownika ochrony fizycznej",
        false:
          "nie posiada zdolności do wykonywania zadań pracownika ochrony fizycznej",
      },
      civilExplosives: {
        true: "nie wykazuje zaburzeń funkcjonowania psychologicznego, a tym samym może wykonywać działalność w zakresie nabywania oraz przechowywania materiałów wybuchowych przeznaczonych do użytku cywilnego",
        false:
          "wykazuje zaburzenia funkcjonowania psychologicznego, a tym samym nie może wykonywać działalności w zakresie nabywania oraz przechowywania materiałów wybuchowych przeznaczonych do użytku cywilnego",
      },
      drivingInstructor: {
        true: "brak przeciwwskazań do wykonywania czynności instruktora/egzaminatora/instruktora techniki jazdy",
        false:
          "istnienie przeciwwskazań do wykonywania czynności instruktora/egzaminatora/instruktora techniki jazdy",
      },
      drivingExaminer: {
        true: "brak przeciwwskazań do wykonywania czynności instruktora/egzaminatora/instruktora techniki jazdy",
        false:
          "istnienie przeciwwskazań do wykonywania czynności instruktora/egzaminatora/instruktora techniki jazdy",
      },
      militaryExplosives: {
        true: "nie wykazuje istotnych zaburzeń funkcjonowania psychologicznego, które stanowią przeszkodę do wykonywania lub kierowania działalnością gospodarczą w zakresie wytwarzania i obrotu materiałami wybuchowymi, bronią, amunicją oraz wyrobami i technologią o przeznaczeniu wojskowym lub policyjnym",
        false:
          "wykazuje istotne zaburzenia funkcjonowania psychologicznego, które stanowią przeszkodę do wykonywania lub kierowania działalnością gospodarczą w zakresie wytwarzania i obrotu materiałami wybuchowymi, bronią, amunicją oraz wyrobami i technologią o przeznaczeniu wojskowym lub policyjnym",
      },
      professionalDriver: {
        true: "brak przeciwwskazań psychologicznych do wykonywania pracy na stanowisku kierowcy",
        false:
          "istnienie przeciwwskazań psychologicznych do wykonywania pracy na stanowisku kierowcy",
      },
      firearmLicense: {
        true: "nie należy do osób wymienionych w art. 15 ust. 1 pkt 3 ustawy z dnia 21 maja 1999 r. o broni amunicji i może dysponować bronią",
        false:
          "należy do osób wymienionych w art. 15 ust. 1 pkt 3 ustawy z dnia 21 maja 1999 r. o broni amunicji i nie może dysponować bronią",
      },
      occupationalMedicine: {
        true: "brak przeciwwskazań psychologicznych do",
        false: "istnienie przeciwwskazań psychologicznych do",
        justification: "Uzasadnienie",
      },
    },
    ExaminationCard: {
      header: "Karta badania",
      headerTEST2WORK: "Karta badania TEST2WORK",
      headerTEST2SAFE: "Karta badania TEST2SAFE",
      headerTEST2ARMS: "Karta badania TEST2ARMS",
      headerTEST2DRIVE: "Karta badania TEST2DRIVE",
      fetchUpdated: "Aktualizuj danymi z wywiadu i wynikami",
      tooltipFetchUpdated:
        "Ta akcja usunie wszystkie niezapisane zmiany z Przebiegu Badania",
      tooltipFetchUpdatedDisabled:
        "W celu odblokowania akcji wybierz normę badania.",
      tabs: {
        examinee: "Osoba badana",
        courseOfExamination: "Przebieg badania",
        results: "Wyniki badania psychologicznego",
      },
      examinee: {
        chosenNormSet: "Norma zastosowana w badaniu",
        examinationDate: "Data Badania",
        previousExaminationDate: "Data poprzedniego badania",
        aim: "Cel badania",
        entityDirectingToExamination: "Podmiot kierujący na badanie",
        t2dAim: {
          drivingVehiclesAim:
            "Stwierdzenie braku lub istnienia przeciwwskazań do kierowania pojazdami.",
          professionalDriverAim:
            "Stwierdzenie braku lub istnienia przeciwwskazań do wykonywania pracy na stanowisku kierowcy.",
          emergencyDriverAim:
            "Stwierdzenie braku lub istnienia przeciwwskazań do kierowania pojazdem uprzywilejowanym lub przewożącym środki pieniężne.",
          drivingInstructorAim:
            "Stwierdzenie braku lub istnienia przeciwwskazań do wykonywania czynności instruktora/egzaminatora/instruktora techniki jazdy.",
        },
      },
      examinationCourse: {
        forcedUpdateHeader:
          "Zaktualizuj Kartę Badania danymi z Wywiadu i Wynikami",
        forcedUpdateBody:
          "W celu odblokowania formularza wypełnij Wywiad dla Badania, wybierz normę w zakładce Osoba Badana i zaktualizuj Kartę Badania danymi z Wywiadu i Wynikami.",
        header: "Dane z wywiadu bezpośredniego i obserwacji osoby badanej",
        methodology: "Metody badania i wyniki",
        recommendations: "Zalecenia",
        conclusions: "Wnioski",
        conclusionsRecomendation: "Wnioski i zalecenia",
        careerHistory: "Przebieg pracy",
        examinationResultsHeader:
          "Nazwa testu i wyniki (w ramach rekomendowanej metodyki)",
        examinationExtendedResultsHeader: "Nazwa testu i wyniki dodatkowe",
        cognitiveResultsHeader:
          "Ocena i opis osoby badanej pod względem sprawności intelektualnej i procesów poznawczych (w ramach rekomendowanej metodyki)",
        cognitiveExtendedResultsHeader:
          "Ocena i opis osoby badanej pod względem sprawności intelektualnej i procesów poznawczych wyniki dodatkowe",
        personalityResultsHeader:
          "Ocena i opis osoby badanej pod względem osobowości, z uwzględnieniem funkcjonowania w trudnych sytuacjach, a także dojrzałości społecznej (w ramach rekomendowanej metodyki)",
        personalityExtendedResultsHeader:
          "Ocena i opis osoby badanej pod względem osobowości, z uwzględnieniem funkcjonowania w trudnych sytuacjach, a także dojrzałości społecznej wyniki dodatkowe",
        psychomotorResultsHeader:
          "Sprawność psychomotoryczna (w ramach rekomendowanej metodyki)",
        psychomotorExtendedResultsHeader:
          "Sprawność psychomotoryczna wyniki dodatkowe",
        occupationalMedicineAdditionalInfo:
          "Dodatkowe informacje - Medycyna pracy",
        examinationResultsT2WHeader: "Rekomendowana metodyka",
        examinationExtendedResultsT2WHeader: "Dodatkowe",
        addExaminationExtendedResults: "Dodaj wynik dodatkowy",
        deletePopup: {
          headerText: "Czy na pewno chcesz usunąć wynik?",
          contentText:
            "Po usunięciu wyniku można przywrócić jego oryginalną treść poprzez aktualizację danych",
          confirmationText: "Tak, chcę usunąć wynik",
        },
      },
      judgment: {
        result: "Wynik badania psychologicznego",
        sent: "Orzeczenie/kopię orzeczenia wysłano, jeżeli dotyczy",
        judgment: "Treść orzeczenia",
        justification: "Uzasadnienie orzeczenia",
        justificationText: "Treść uzasadnienia",
        recommendations: "Zalecenia",
        to: "do",
        t2d: {
          lack: "brak",
          existing: "istnieje",
          questions: {
            drivingVehiclesContraindication:
              "Przeciwwskazania do kierowania pojazdami.",
            professionalDriverContraindication:
              "Przeciwwskazania do wykonywania pracy na stanowisku kierowcy.",
            emergencyVehicleDriverContraindication:
              "Przeciwwskazania do kierowania pojazdem uprzywilejowanym lub przewożącym środki pieniężne.",
            drivingInstructorContraindication:
              "Przeciwwskazania do wykonywania czynności instruktora/egzaminatora/instruktora techniki jazdy.",
          },
        },
      },
    },
  },
  TwoFactor: {
    setupTitle: "Skonfiguruj uwierzytelnianie dwuskładnikowe",
    verifyTitle: "Zweryfikuj uwierzytelnianie dwuskładnikowe",
    disableTitle: "Wyłącz uwierzytelnianie dwuskładnikowe",
    scanQRCode: "Zeskanuj ten kod QR za pomocą aplikacji uwierzytelniającej",
    secretKey: "Klucz tajny",
    backupCodes: "Kody zapasowe",
    backupCodesInfo:
      "Zapisz te kody zapasowe w bezpiecznym miejscu. Możesz ich użyć, aby uzyskać dostęp do swojego konta, jeśli utracisz urządzenie uwierzytelniające.",
    enterCode: "Wprowadź kod weryfikacyjny z aplikacji uwierzytelniającej",
    verificationCode: "Kod weryfikacyjny",
    confirmDisable:
      "Wprowadź hasło, aby wyłączyć uwierzytelnianie dwuskładnikowe",
    setupError: "Nie udało się skonfigurować uwierzytelniania dwuskładnikowego",
    verificationError: "Nieprawidłowy kod weryfikacyjny",
    disableError: "Nie udało się wyłączyć uwierzytelniania dwuskładnikowego",
    setupSuccess:
      "Uwierzytelnianie dwuskładnikowe zostało pomyślnie skonfigurowane",
    disableSuccess:
      "Uwierzytelnianie dwuskładnikowe zostało pomyślnie wyłączone",
    useBackupCode: "Użyj kodu zapasowego",
    useAuthenticator: "Użyj aplikacji uwierzytelniającej",
    enterBackupCode: "Wprowadź kod zapasowy",
    backupCode: "Kod zapasowy",
  },
  CsvHeaders: {
    firstName: "Imię",
    lastName: "Nazwisko",
    identificationNumber: "Identyfikator",
    directoryName: "Nazwa folderu",
  },
  CsvFileName: {
    examineesList: "lista-badanych",
  },
  SystemParams: {
    showBatteriesDesc:
      "flaga mówiąca czy wyświetlać baterie przy zapraszaniu do badania, wartości: 0, 1",
    t2sTestsDesc:
      "lista testów domyślnie zaznaczonych przy wyborze metodyki T2S, przykładowa wartość: SIRT,CHORT,HECOR....",
    t2aTestsDesc:
      "lista testów domyślnie zaznaczonych przy wyborze metodyki T2A, przykładowa wartość: SIRT,CHORT,HECOR....",
    t2wTestsDesc:
      "lista testów domyślnie zaznaczonych przy wyborze metodyki T2W, przykładowa wartość: SIRT,CHORT,HECOR....",
    t2dTestsDesc:
      "lista testów domyślnie zaznaczonych przy wyborze metodyki T2D, przykładowa wartość: SIRT,CHORT,HECOR....",
    selectTestsDesc:
      "lista testów domyślnie zaznaczonych przy zapraszaniu bez podstawy prawnej, przykładowa wartość: SIRT,CHORT,HECOR....",
    batteriesListDesc:
      "lista baterii widoczna przy zapraszaniu do badania jesli paramter SHOW_BATTERIES ustawiono na 1, przykładowa wartość: TEST2DRIVE,TEST2SPORT...",
    showExtendedExamDesc:
      "Czy umożliwiać rozszerzanie zamkniętych badań o nowe testy, wartości: 0, 1",
    showRecalculateExamDesc:
      "Czy pokazywać na liście badań akcję przeliczania badania dla administratorów laboratorium (is_admin), wartości: 0, 1",
    showExamineeRegistryDesc:
      "Rejestr badanych dostępny z panelu psychologa – czy wyświetlać moduł rejestru badanych, wartości: 0, 1",
    showImportExamineeDesc:
      "Import badanych dostępny z panelu psychologa, wartości: 0, 1",
    allowExportResultDesc:
      "Eksport wyników dostępny z panelu psychologa, wartości: 0, 1",
    passwordExpiryDaysDesc:
      "Liczba dni ważności hasła użytkownika (np. 30, 60, 90)",
    allowDelExaminessDesc:
      "Czy umożliwić usuwanie wielu badanych jednocześnie, wartości: 0, 1",
    allowDelExamineeWithExamDesc:
      "Czy umożliwić usunięcie badanego wraz z badaniami, wartości: 0, 1",
    batteries: "Bateria",
  },
};